// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type MutationOptions,
  queryOptions,
} from '@tanstack/solid-query';

import { client } from '../client.gen';
import {
  activityDetailsbyactivityId,
  activitylogsbyactivityId,
  addaNewFolderPermission,
  addattachments,
  addCompanyEmailDomains,
  addfiles,
  addInviteUserstoproject,
  addobjectstoTag,
  addReactionToComment,
  addUserstoCompany,
  adduserstogroup,
  bulkcreateobjectlinks,
  checkinFile,
  checkoutFile,
  cloneProject,
  commitFileUpload,
  completeMultipartFileUpload,
  createa2dViewMultipart,
  createAlignment,
  createalignmentwithmatrix,
  createaNew2dView,
  createaNewClash,
  createaNewComment,
  createaNewFolder,
  createaNewGroup,
  createaNewProject,
  createaNewRelease,
  createaNewShare,
  createaNewToDo,
  createaViewGroup,
  createMarkups,
  createNewExportRequest,
  createobjectlink,
  createSectionPlane,
  createTag,
  createView,
  createViewWithThumbnail,
  delete2dView,
  deletealignment,
  deleteaobjectlink,
  deleteClash,
  deleteComment,
  deleteFile,
  deleteFolder,
  deleteFolder2,
  deleteGroup,
  deleteMarkup,
  deleteProject,
  deleteReactionToComment,
  deleteRelease,
  deleteRemoveattachments,
  deleteReservedViewData,
  deleteSectionBox,
  deleteSectionPlane,
  deleteShare,
  deleteTag,
  deleteToDo,
  deleteusersfromgroup,
  deleteView,
  deleteViewGroup,
  downloadfilesinrelease,
  downloadUrl,
  editRelease,
  editShare,
  editTag,
  get2dViewdetails,
  getActiveFileFolderSnapshot,
  getalignment,
  getAvailableRegions,
  getCameraDetails,
  getClashDetails,
  getCommentDetails,
  getCompanyDetails,
  getExportdetails,
  getExportDetails,
  getFileDetails,
  getFileFolderDetailsByName,
  getFilePermissions,
  getFileUploadDetails,
  getFileUploadStatus,
  getFolderDeletionJobStatus,
  getFolderDetails,
  getFolderPermissions,
  getFolderPermissions2,
  getGroupDetails,
  getListallattachments,
  getPresentation,
  getprocessingstatusofaFile,
  getProjectCloneDetails,
  getProjectDetails,
  getProjectlicensedetails,
  getProjectMetrics,
  getProjectsettings,
  getProjectSyncObjects,
  getProjectSyncStatus,
  getProjectUserDetails,
  getReleaseDetails,
  getReservedViewData,
  getSectionBox,
  getShareDetails,
  getShareDetailsWithAccessTokenUsingStoken,
  getTagDetails,
  getToDoDetails,
  getUserDetails,
  getversionsofaFile,
  getversionsofaFolder,
  getViewDetails,
  getViewGroupDetails,
  getViewImage,
  initiateFilePackageUpload,
  initiateFileUpload,
  listActivitiesofaProjectObject,
  listall2dViews,
  listallattachments,
  listAllAvailableTimezones,
  listallClashesinaproject,
  listAllClashItems,
  listallComments,
  listallfiles,
  listallProjects,
  listAllProjectsMini,
  listAllProjectsV21,
  listallReleases,
  listAllSearchResults,
  listallShares,
  listAllSupportedLanguages,
  listallToDos,
  listallTodoTypesofaProject,
  listallUsersinproject,
  listallViewGroups,
  listallViewsinaproject,
  listCompanies,
  listGroupsinaproject,
  listItemsinaFolder,
  listItemsinaFolderbypath,
  listItemsinaFolderByPath,
  listItemsinaFolderV21,
  listlinkedentitiesforobjects,
  listlinksforthegiventargetentity,
  listMarkups,
  listobjectsinaTag,
  listReactionsToComment,
  listrolesavailableinproject,
  listSectionPlanes,
  listSupported2d3dSpatialfileformats,
  listTagsinaproject,
  listUserLicenses,
  listUsersinaCompany,
  listUsersinaGroup,
  type Options,
  patchFilePermissions,
  patchFolderPermissions,
  postActivitiesList,
  postAddattachments,
  postCreateanewexportRequest,
  putReservedViewData,
  removeanyexistingFolderPermission,
  removeattachments,
  removeCompanyEmailDomains,
  removefiles,
  removeobjectsfromTag,
  removeuser,
  removeUserfromtheCompany,
  removeUsersfromCompany,
  renameGroup,
  requestProjectAccess,
  update2dView,
  update2dViewMultipart,
  updateCamera,
  updateClash,
  updateComment,
  updateCompany,
  updateexistingFolderPermission,
  updateFileDetails,
  updateFolder,
  updateMarkup,
  updateobjectlinks,
  updatePresentation,
  updateProject,
  updateProjectLicenseDetails,
  updateProjectSettings,
  updateSectionBox,
  updateSectionPlane,
  updateToDo,
  updateUserDetails,
  updateUserintheCompany,
  updateUserrole,
  updateView,
  updateViewGroupDetails,
  updateViewWithThumbnail,
  uploadCompanyImage,
  uploadFile,
  uploadProjectImage,
  uploadViewThumbnailImage,
} from '../sdk.gen';
import type {
  ActivityDetailsbyactivityIdData,
  ActivityDetailsbyactivityIdResponse,
  ActivitylogsbyactivityIdData,
  ActivitylogsbyactivityIdResponse,
  AddaNewFolderPermissionData,
  AddaNewFolderPermissionResponse,
  AddattachmentsData,
  AddattachmentsResponse,
  AddCompanyEmailDomainsData,
  AddCompanyEmailDomainsResponse,
  AddfilesData,
  AddfilesResponse,
  AddInviteUserstoprojectData,
  AddInviteUserstoprojectResponse,
  AddobjectstoTagData,
  AddobjectstoTagResponse,
  AddReactionToCommentData,
  AddReactionToCommentResponse2,
  AddUserstoCompanyData,
  AddUserstoCompanyResponse,
  AdduserstogroupData,
  AdduserstogroupResponse,
  BulkcreateobjectlinksData,
  BulkcreateobjectlinksResponse,
  CheckinFileData,
  CheckinFileResponse,
  CheckoutFileData,
  CheckoutFileResponse,
  CloneProjectData,
  CloneProjectResponse,
  CommitFileUploadData,
  CommitFileUploadError,
  CompleteMultipartFileUploadData,
  CompleteMultipartFileUploadError,
  CompleteMultipartFileUploadResponse,
  Createa2dViewMultipartData,
  Createa2dViewMultipartResponse,
  CreateAlignmentData,
  CreateAlignmentResponse,
  CreatealignmentwithmatrixData,
  CreatealignmentwithmatrixResponse,
  CreateaNew2dViewData,
  CreateaNew2dViewResponse,
  CreateaNewClashData,
  CreateaNewClashResponse,
  CreateaNewCommentData,
  CreateaNewCommentResponse,
  CreateaNewFolderData,
  CreateaNewFolderResponse,
  CreateaNewGroupData,
  CreateaNewGroupResponse,
  CreateaNewProjectData,
  CreateaNewProjectResponse,
  CreateaNewReleaseData,
  CreateaNewReleaseResponse,
  CreateaNewShareData,
  CreateaNewShareResponse,
  CreateaNewToDoData,
  CreateaNewToDoResponse,
  CreateaViewGroupData,
  CreateaViewGroupResponse,
  CreateMarkupsData,
  CreateMarkupsResponse,
  CreateNewExportRequestData,
  CreateNewExportRequestResponse,
  CreateobjectlinkData,
  CreateobjectlinkResponse,
  CreateSectionPlaneData,
  CreateSectionPlaneResponse,
  CreateTagData,
  CreateTagResponse,
  CreateViewData,
  CreateViewResponse,
  CreateViewWithThumbnailData,
  CreateViewWithThumbnailResponse,
  Delete2dViewData,
  Delete2dViewResponse,
  DeletealignmentData,
  DeletealignmentResponse,
  DeleteaobjectlinkData,
  DeleteaobjectlinkResponse,
  DeleteClashData,
  DeleteClashResponse,
  DeleteCommentData,
  DeleteCommentResponse,
  DeleteFileData,
  DeleteFileResponse,
  DeleteFolder2Data,
  DeleteFolder2Error,
  DeleteFolder2Response,
  DeleteFolderData,
  DeleteFolderResponse,
  DeleteGroupData,
  DeleteGroupResponse,
  DeleteMarkupData,
  DeleteMarkupResponse,
  DeleteProjectData,
  DeleteProjectResponse,
  DeleteReactionToCommentData,
  DeleteReactionToCommentResponse,
  DeleteReleaseData,
  DeleteReleaseResponse,
  DeleteRemoveattachmentsData,
  DeleteRemoveattachmentsResponse,
  DeleteReservedViewDataData,
  DeleteReservedViewDataResponse,
  DeleteSectionBoxData,
  DeleteSectionBoxResponse,
  DeleteSectionPlaneData,
  DeleteSectionPlaneResponse,
  DeleteShareData,
  DeleteShareResponse,
  DeleteTagData,
  DeleteTagResponse,
  DeleteToDoData,
  DeleteToDoResponse,
  DeleteusersfromgroupData,
  DeleteusersfromgroupResponse,
  DeleteViewData,
  DeleteViewGroupData,
  DeleteViewGroupResponse,
  DeleteViewResponse,
  DownloadfilesinreleaseData,
  DownloadUrlData,
  DownloadUrlResponse2,
  EditReleaseData,
  EditReleaseResponse,
  EditShareData,
  EditShareResponse,
  EditTagData,
  EditTagResponse,
  Get2dViewdetailsData,
  Get2dViewdetailsResponse,
  GetActiveFileFolderSnapshotData,
  GetActiveFileFolderSnapshotError,
  GetActiveFileFolderSnapshotResponse,
  GetalignmentData,
  GetalignmentResponse2,
  GetAvailableRegionsData,
  GetAvailableRegionsResponse2,
  GetCameraDetailsData,
  GetCameraDetailsResponse,
  GetClashDetailsData,
  GetClashDetailsResponse,
  GetCommentDetailsData,
  GetCommentDetailsResponse,
  GetCompanyDetailsData,
  GetCompanyDetailsResponse,
  GetExportdetailsData,
  GetExportDetailsData,
  GetExportdetailsResponse,
  GetExportDetailsResponse,
  GetFileDetailsData,
  GetFileDetailsError,
  GetFileDetailsResponse,
  GetFileFolderDetailsByNameData,
  GetFileFolderDetailsByNameError,
  GetFileFolderDetailsByNameResponse,
  GetFilePermissionsData,
  GetFilePermissionsError,
  GetFilePermissionsResponse,
  GetFileUploadDetailsData,
  GetFileUploadDetailsError,
  GetFileUploadDetailsResponse,
  GetFileUploadStatusData,
  GetFileUploadStatusError,
  GetFileUploadStatusResponse,
  GetFolderDeletionJobStatusData,
  GetFolderDeletionJobStatusError,
  GetFolderDetailsData,
  GetFolderDetailsError,
  GetFolderDetailsResponse,
  GetFolderPermissions2Data,
  GetFolderPermissions2Response,
  GetFolderPermissionsData,
  GetFolderPermissionsError,
  GetFolderPermissionsResponse,
  GetGroupDetailsData,
  GetGroupDetailsResponse,
  GetListallattachmentsData,
  GetListallattachmentsResponse,
  GetPresentationData,
  GetPresentationResponse,
  GetprocessingstatusofaFileData,
  GetprocessingstatusofaFileResponse2,
  GetProjectCloneDetailsData,
  GetProjectCloneDetailsResponse,
  GetProjectDetailsData,
  GetProjectDetailsResponse,
  GetProjectlicensedetailsData,
  GetProjectlicensedetailsResponse,
  GetProjectMetricsData,
  GetProjectMetricsResponse,
  GetProjectsettingsData,
  GetProjectsettingsResponse,
  GetProjectSyncObjectsData,
  GetProjectSyncObjectsError,
  GetProjectSyncObjectsResponse,
  GetProjectSyncStatusData,
  GetProjectSyncStatusResponse,
  GetProjectUserDetailsData,
  GetProjectUserDetailsResponse,
  GetReleaseDetailsData,
  GetReleaseDetailsResponse,
  GetReservedViewDataData,
  GetReservedViewDataResponse,
  GetSectionBoxData,
  GetSectionBoxResponse,
  GetShareDetailsData,
  GetShareDetailsResponse,
  GetShareDetailsWithAccessTokenUsingStokenData,
  GetShareDetailsWithAccessTokenUsingStokenResponse,
  GetTagDetailsData,
  GetTagDetailsResponse,
  GetToDoDetailsData,
  GetToDoDetailsResponse,
  GetUserDetailsData,
  GetUserDetailsResponse2,
  GetversionsofaFileData,
  GetversionsofaFileResponse,
  GetversionsofaFolderData,
  GetversionsofaFolderResponse,
  GetViewDetailsData,
  GetViewDetailsResponse,
  GetViewGroupDetailsData,
  GetViewGroupDetailsResponse,
  GetViewImageData,
  GetViewImageResponse,
  InitiateFilePackageUploadData,
  InitiateFilePackageUploadError,
  InitiateFilePackageUploadResponse,
  InitiateFileUploadData,
  InitiateFileUploadError,
  ListActivitiesofaProjectObjectData,
  ListActivitiesofaProjectObjectResponse,
  Listall2dViewsData,
  Listall2dViewsResponse,
  ListallattachmentsData,
  ListallattachmentsResponse,
  ListAllAvailableTimezonesData,
  ListAllAvailableTimezonesResponse,
  ListallClashesinaprojectData,
  ListallClashesinaprojectResponse,
  ListAllClashItemsData,
  ListAllClashItemsResponse2,
  ListallCommentsData,
  ListallCommentsResponse,
  ListallfilesData,
  ListallfilesResponse,
  ListallProjectsData,
  ListAllProjectsMiniData,
  ListAllProjectsMiniResponse,
  ListallProjectsResponse,
  ListAllProjectsV21Data,
  ListAllProjectsV21Error,
  ListAllProjectsV21Response,
  ListallReleasesData,
  ListallReleasesResponse,
  ListAllSearchResultsData,
  ListAllSearchResultsResponse2,
  ListallSharesData,
  ListallSharesResponse,
  ListAllSupportedLanguagesData,
  ListAllSupportedLanguagesResponse,
  ListallToDosData,
  ListallToDosResponse,
  ListallTodoTypesofaProjectData,
  ListallTodoTypesofaProjectResponse,
  ListallUsersinprojectData,
  ListallUsersinprojectResponse,
  ListallViewGroupsData,
  ListallViewGroupsResponse,
  ListallViewsinaprojectData,
  ListallViewsinaprojectResponse,
  ListCompaniesData,
  ListCompaniesResponse,
  ListGroupsinaprojectData,
  ListGroupsinaprojectResponse,
  ListItemsinaFolderbypathData,
  ListItemsinaFolderByPathData,
  ListItemsinaFolderByPathError,
  ListItemsinaFolderbypathResponse,
  ListItemsinaFolderByPathResponse,
  ListItemsinaFolderData,
  ListItemsinaFolderError,
  ListItemsinaFolderResponse2,
  ListItemsinaFolderV21Data,
  ListItemsinaFolderV21Response,
  ListlinkedentitiesforobjectsData,
  ListlinkedentitiesforobjectsResponse,
  ListlinksforthegiventargetentityData,
  ListlinksforthegiventargetentityResponse,
  ListMarkupsData,
  ListMarkupsResponse,
  ListobjectsinaTagData,
  ListobjectsinaTagResponse,
  ListReactionsToCommentData,
  ListReactionsToCommentResponse,
  ListrolesavailableinprojectData,
  ListrolesavailableinprojectResponse,
  ListSectionPlanesData,
  ListSectionPlanesResponse,
  ListSupported2D3dSpatialfileformatsData,
  ListSupported2D3dSpatialfileformatsResponse,
  ListTagsinaprojectData,
  ListTagsinaprojectResponse,
  ListUserLicensesData,
  ListUserLicensesResponse,
  ListUsersinaCompanyData,
  ListUsersinaCompanyResponse,
  ListUsersinaGroupData,
  ListUsersinaGroupResponse,
  PatchFilePermissionsData,
  PatchFilePermissionsError,
  PatchFilePermissionsResponse,
  PatchFolderPermissionsData,
  PatchFolderPermissionsError,
  PatchFolderPermissionsResponse,
  PostActivitiesListData,
  PostActivitiesListResponse,
  PostAddattachmentsData,
  PostAddattachmentsResponse,
  PostCreateanewexportRequestData,
  PostCreateanewexportRequestResponse,
  PutReservedViewDataData,
  PutReservedViewDataResponse,
  RemoveanyexistingFolderPermissionData,
  RemoveanyexistingFolderPermissionResponse,
  RemoveattachmentsData,
  RemoveattachmentsResponse,
  RemoveCompanyEmailDomainsData,
  RemoveCompanyEmailDomainsResponse,
  RemovefilesData,
  RemovefilesResponse,
  RemoveobjectsfromTagData,
  RemoveobjectsfromTagResponse,
  RemoveuserData,
  RemoveUserfromtheCompanyData,
  RemoveUserfromtheCompanyResponse,
  RemoveuserResponse,
  RemoveUsersfromCompanyData,
  RemoveUsersfromCompanyResponse,
  RenameGroupData,
  RenameGroupResponse,
  RequestProjectAccessData,
  Update2dViewData,
  Update2dViewMultipartData,
  Update2dViewMultipartResponse,
  Update2dViewResponse,
  UpdateCameraData,
  UpdateCameraResponse,
  UpdateClashData,
  UpdateClashResponse,
  UpdateCommentData,
  UpdateCommentResponse,
  UpdateCompanyData,
  UpdateCompanyResponse,
  UpdateexistingFolderPermissionData,
  UpdateexistingFolderPermissionResponse,
  UpdateFileDetailsData,
  UpdateFileDetailsResponse,
  UpdateFolderData,
  UpdateFolderError,
  UpdateFolderResponse,
  UpdateMarkupData,
  UpdateMarkupResponse,
  UpdateobjectlinksData,
  UpdateobjectlinksResponse,
  UpdatePresentationData,
  UpdatePresentationResponse,
  UpdateProjectData,
  UpdateProjectLicenseDetailsData,
  UpdateProjectResponse,
  UpdateProjectSettingsData,
  UpdateSectionBoxData,
  UpdateSectionBoxResponse,
  UpdateSectionPlaneData,
  UpdateSectionPlaneResponse,
  UpdateToDoData,
  UpdateToDoResponse,
  UpdateUserDetailsData,
  UpdateUserDetailsResponse,
  UpdateUserintheCompanyData,
  UpdateUserintheCompanyResponse,
  UpdateUserroleData,
  UpdateUserroleResponse,
  UpdateViewData,
  UpdateViewGroupDetailsData,
  UpdateViewGroupDetailsResponse,
  UpdateViewResponse,
  UpdateViewWithThumbnailData,
  UpdateViewWithThumbnailResponse,
  UploadCompanyImageData,
  UploadCompanyImageResponse,
  UploadFileData,
  UploadFileResponse,
  UploadProjectImageData,
  UploadProjectImageResponse,
  UploadViewThumbnailImageData,
  UploadViewThumbnailImageResponse2,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const listItemsinaFolderByPathQueryKey = (
  options: Options<ListItemsinaFolderByPathData>
) => createQueryKey('listItemsinaFolderByPath', options);

/**
 * List Items in a Folder by Path
 *
 * List Items in a Folder by Path
 * API to list all items in a folder specified by a path within a project, with cursor-based pagination and optional field selection.
 *
 * The `links.next.href` property in the response contains the URL to the next page of results. If there are no more results, the `links.next.href` property is not present in the response.
 * The requester is expected to call `links.next.href` to fetch the rest of the resources, if `links.next.href` is present in the response.
 *
 * **Pagination** : Uses cursor-based pagination with `skipToken` and `pageSize` parameters.
 * **Field Selection**: Use the `fields` parameter to include optional fields information.
 * **Sorting** : Supports composed order sorting with `sort` parameter.
 * **Path-based Access**: Specify folder location using relative path within a project.
 *
 */
export const listItemsinaFolderByPathOptions = (
  options: Options<ListItemsinaFolderByPathData>
) =>
  queryOptions<
    ListItemsinaFolderByPathResponse,
    ListItemsinaFolderByPathError,
    ListItemsinaFolderByPathResponse,
    ReturnType<typeof listItemsinaFolderByPathQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listItemsinaFolderByPath({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listItemsinaFolderByPathQueryKey(options),
  });

export const listItemsinaFolderQueryKey = (
  options: Options<ListItemsinaFolderData>
) => createQueryKey('listItemsinaFolder', options);

/**
 * List Items in a Folder
 *
 * List Items in a Folder
 * API to list all items in a folder with cursor-based pagination and optional field selection.
 *
 * The `links.next.href` property in the response contains the URL to the next page of results. If there are no more results, the `links.next.href` property is not present in the response.
 * The requester is expected to call `links.next.href` to fetch the rest of the resources,if `links.next.href` is present in the response.
 *
 * **Pagination** : Uses cursor-based pagination with `skipToken` and `pageSize` parameters.
 * **Field Selection**: Use the `fields` parameter to include optional fields information.
 * **Sorting** : Supports composed order sorting with `sort` parameter.
 *
 */
export const listItemsinaFolderOptions = (
  options: Options<ListItemsinaFolderData>
) =>
  queryOptions<
    ListItemsinaFolderResponse2,
    ListItemsinaFolderError,
    ListItemsinaFolderResponse2,
    ReturnType<typeof listItemsinaFolderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listItemsinaFolder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listItemsinaFolderQueryKey(options),
  });

export const listAllProjectsV21QueryKey = (
  options?: Options<ListAllProjectsV21Data>
) => createQueryKey('listAllProjectsV21', options);

/**
 * List all Projects (v2.1)
 *
 * API to list all projects for the user with cursor-based pagination and optional field selection.
 *
 * The `links.next.href` property in the response contains the URL to the next page of results. If there are no more results, the `links.next.href` property is not present in the response.
 * Server may return response with `links.next.href` property even if the response contains no / lesser than requested(pageSize) items.
 * Server may return less items than `pageSize` requested (or even zero). It could happen e.g. if resources requested are too large to fit into a single response
 * or if some (or all `pageSize` requested) resources are not accessible to the requester. In this case requester is expected to call `links.next.href` to fetch the rest of the resources,if `links.next.href` is present in the response.
 * In extreme cases response could be empty with the `links.next.href` present, it means that all resources on the current page is not accessible to the requester.
 *
 * **Pagination**: Uses cursor-based pagination with `skipToken` and `pageSize` parameters.
 * **Field Selection**: Use the `fields` parameter to include optional license and description information.
 * **Sorting**: Supports single-field sorting with `sortBy` parameter.
 *
 */
export const listAllProjectsV21Options = (
  options?: Options<ListAllProjectsV21Data>
) =>
  queryOptions<
    ListAllProjectsV21Response,
    ListAllProjectsV21Error,
    ListAllProjectsV21Response,
    ReturnType<typeof listAllProjectsV21QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAllProjectsV21({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAllProjectsV21QueryKey(options),
  });

export const listActivitiesofaProjectObjectQueryKey = (
  options: Options<ListActivitiesofaProjectObjectData>
) => createQueryKey('listActivitiesofaProjectObject', options);

/**
 * List Activities of a Project / Object
 *
 * API to list the activities in a project / specific object
 */
export const listActivitiesofaProjectObjectOptions = (
  options: Options<ListActivitiesofaProjectObjectData>
) =>
  queryOptions<
    ListActivitiesofaProjectObjectResponse,
    DefaultError,
    ListActivitiesofaProjectObjectResponse,
    ReturnType<typeof listActivitiesofaProjectObjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listActivitiesofaProjectObject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listActivitiesofaProjectObjectQueryKey(options),
  });

/**
 * Create a new export Request
 *
 * This API is used to create export Request for activities in a project.
 */
export const postCreateanewexportRequestMutation = (
  options?: Partial<Options<PostCreateanewexportRequestData>>
): MutationOptions<
  PostCreateanewexportRequestResponse,
  DefaultError,
  Options<PostCreateanewexportRequestData>
> => {
  const mutationOptions: MutationOptions<
    PostCreateanewexportRequestResponse,
    DefaultError,
    Options<PostCreateanewexportRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postCreateanewexportRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getExportdetailsQueryKey = (
  options: Options<GetExportdetailsData>
) => createQueryKey('getExportdetails', options);

/**
 * Get export details
 *
 * API to fetch details of the export activities.
 */
export const getExportdetailsOptions = (
  options: Options<GetExportdetailsData>
) =>
  queryOptions<
    GetExportdetailsResponse,
    DefaultError,
    GetExportdetailsResponse,
    ReturnType<typeof getExportdetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExportdetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExportdetailsQueryKey(options),
  });

/**
 * List activities with filters
 *
 * This API is used to list activities with filters.The `filters` in the request body can be used to filter the list of activities by a start and end date, by list of users or usergroups who performed actions that created the activities, and by list of activity types.  <br> This API can also be used to list activities by specific objectId and objectType by using the query parameters. <br> This API uses cursor based pagination (see `lastId` and `pageSize` query params) and does not support range headers.
 */
export const postActivitiesListMutation = (
  options?: Partial<Options<PostActivitiesListData>>
): MutationOptions<
  PostActivitiesListResponse,
  DefaultError,
  Options<PostActivitiesListData>
> => {
  const mutationOptions: MutationOptions<
    PostActivitiesListResponse,
    DefaultError,
    Options<PostActivitiesListData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postActivitiesList({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const activityDetailsbyactivityIdQueryKey = (
  options: Options<ActivityDetailsbyactivityIdData>
) => createQueryKey('activityDetailsbyactivityId', options);

/**
 * Activity Details by activityId
 *
 * API to fetch details an activity by id
 */
export const activityDetailsbyactivityIdOptions = (
  options: Options<ActivityDetailsbyactivityIdData>
) =>
  queryOptions<
    ActivityDetailsbyactivityIdResponse,
    DefaultError,
    ActivityDetailsbyactivityIdResponse,
    ReturnType<typeof activityDetailsbyactivityIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await activityDetailsbyactivityId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: activityDetailsbyactivityIdQueryKey(options),
  });

export const activitylogsbyactivityIdQueryKey = (
  options: Options<ActivitylogsbyactivityIdData>
) => createQueryKey('activitylogsbyactivityId', options);

/**
 * Activity logs by activityId
 *
 * API to fetch list of logs of an activity by id
 */
export const activitylogsbyactivityIdOptions = (
  options: Options<ActivitylogsbyactivityIdData>
) =>
  queryOptions<
    ActivitylogsbyactivityIdResponse,
    DefaultError,
    ActivitylogsbyactivityIdResponse,
    ReturnType<typeof activitylogsbyactivityIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await activitylogsbyactivityId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: activitylogsbyactivityIdQueryKey(options),
  });

export const listallClashesinaprojectQueryKey = (
  options: Options<ListallClashesinaprojectData>
) => createQueryKey('listallClashesinaproject', options);

/**
 * List all Clashes in a project
 *
 * List all Clashes in a project
 */
export const listallClashesinaprojectOptions = (
  options: Options<ListallClashesinaprojectData>
) =>
  queryOptions<
    ListallClashesinaprojectResponse,
    DefaultError,
    ListallClashesinaprojectResponse,
    ReturnType<typeof listallClashesinaprojectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallClashesinaproject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallClashesinaprojectQueryKey(options),
  });

/**
 * Create a New Clash
 *
 * You can create a new Clash Report using this action.
 */
export const createaNewClashMutation = (
  options?: Partial<Options<CreateaNewClashData>>
): MutationOptions<
  CreateaNewClashResponse,
  DefaultError,
  Options<CreateaNewClashData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNewClashResponse,
    DefaultError,
    Options<CreateaNewClashData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNewClash({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a Clash
 *
 * Delete a Clash
 */
export const deleteClashMutation = (
  options?: Partial<Options<DeleteClashData>>
): MutationOptions<
  DeleteClashResponse,
  DefaultError,
  Options<DeleteClashData>
> => {
  const mutationOptions: MutationOptions<
    DeleteClashResponse,
    DefaultError,
    Options<DeleteClashData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteClash({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getClashDetailsQueryKey = (
  options: Options<GetClashDetailsData>
) => createQueryKey('getClashDetails', options);

/**
 * Get Clash Details
 *
 * Get Clash Details
 */
export const getClashDetailsOptions = (options: Options<GetClashDetailsData>) =>
  queryOptions<
    GetClashDetailsResponse,
    DefaultError,
    GetClashDetailsResponse,
    ReturnType<typeof getClashDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getClashDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getClashDetailsQueryKey(options),
  });

/**
 * Update Clash
 *
 * This API allows you to update the following properties of the Clash:
 *
 * - name
 *
 * - assignees
 */
export const updateClashMutation = (
  options?: Partial<Options<UpdateClashData>>
): MutationOptions<
  UpdateClashResponse,
  DefaultError,
  Options<UpdateClashData>
> => {
  const mutationOptions: MutationOptions<
    UpdateClashResponse,
    DefaultError,
    Options<UpdateClashData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateClash({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listAllClashItemsQueryKey = (
  options: Options<ListAllClashItemsData>
) => createQueryKey('listAllClashItems', options);

/**
 * List All Clash Items
 *
 * This API returns a list of clash-items in the Clash.
 * **Note** : The center point will not be present for clash-items of legacy viewer based clashsets.
 */
export const listAllClashItemsOptions = (
  options: Options<ListAllClashItemsData>
) =>
  queryOptions<
    ListAllClashItemsResponse2,
    DefaultError,
    ListAllClashItemsResponse2,
    ReturnType<typeof listAllClashItemsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAllClashItems({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAllClashItemsQueryKey(options),
  });

export const listallCommentsQueryKey = (
  options: Options<ListallCommentsData>
) => createQueryKey('listallComments', options);

/**
 * List all Comments
 *
 * List all Comments
 */
export const listallCommentsOptions = (options: Options<ListallCommentsData>) =>
  queryOptions<
    ListallCommentsResponse,
    DefaultError,
    ListallCommentsResponse,
    ReturnType<typeof listallCommentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallComments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallCommentsQueryKey(options),
  });

/**
 * Create a New Comment
 *
 * You may create a new Comment using this action.
 */
export const createaNewCommentMutation = (
  options?: Partial<Options<CreateaNewCommentData>>
): MutationOptions<
  CreateaNewCommentResponse,
  DefaultError,
  Options<CreateaNewCommentData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNewCommentResponse,
    DefaultError,
    Options<CreateaNewCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNewComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a Comment
 *
 * Delete a Comment
 */
export const deleteCommentMutation = (
  options?: Partial<Options<DeleteCommentData>>
): MutationOptions<
  DeleteCommentResponse,
  DefaultError,
  Options<DeleteCommentData>
> => {
  const mutationOptions: MutationOptions<
    DeleteCommentResponse,
    DefaultError,
    Options<DeleteCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCommentDetailsQueryKey = (
  options: Options<GetCommentDetailsData>
) => createQueryKey('getCommentDetails', options);

/**
 * Get Comment Details
 *
 * Get Comment Details
 */
export const getCommentDetailsOptions = (
  options: Options<GetCommentDetailsData>
) =>
  queryOptions<
    GetCommentDetailsResponse,
    DefaultError,
    GetCommentDetailsResponse,
    ReturnType<typeof getCommentDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCommentDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCommentDetailsQueryKey(options),
  });

/**
 * Update Comment
 *
 * This API allows you to update description of the Comment:
 */
export const updateCommentMutation = (
  options?: Partial<Options<UpdateCommentData>>
): MutationOptions<
  UpdateCommentResponse,
  DefaultError,
  Options<UpdateCommentData>
> => {
  const mutationOptions: MutationOptions<
    UpdateCommentResponse,
    DefaultError,
    Options<UpdateCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove attachments
 *
 * These set of APIs allow you to remove attachments to a Comment.
 *
 * This api takes request body as given below <br/>
 * [ <br/>
 * { <br/>
 * "id": "woC32em2Fb0",<br/>
 * "type": "FILE"<br/>
 * }<br/>
 * ]
 */
export const deleteRemoveattachmentsMutation = (
  options?: Partial<Options<DeleteRemoveattachmentsData>>
): MutationOptions<
  DeleteRemoveattachmentsResponse,
  DefaultError,
  Options<DeleteRemoveattachmentsData>
> => {
  const mutationOptions: MutationOptions<
    DeleteRemoveattachmentsResponse,
    DefaultError,
    Options<DeleteRemoveattachmentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteRemoveattachments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getListallattachmentsQueryKey = (
  options: Options<GetListallattachmentsData>
) => createQueryKey('getListallattachments', options);

/**
 * List all attachments
 *
 * These set of APIs allow you to list attachments to a Comment.
 */
export const getListallattachmentsOptions = (
  options: Options<GetListallattachmentsData>
) =>
  queryOptions<
    GetListallattachmentsResponse,
    DefaultError,
    GetListallattachmentsResponse,
    ReturnType<typeof getListallattachmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getListallattachments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getListallattachmentsQueryKey(options),
  });

/**
 * Add attachments
 *
 * These set of APIs allow you to add attachments to a Comment.
 */
export const postAddattachmentsMutation = (
  options?: Partial<Options<PostAddattachmentsData>>
): MutationOptions<
  PostAddattachmentsResponse,
  DefaultError,
  Options<PostAddattachmentsData>
> => {
  const mutationOptions: MutationOptions<
    PostAddattachmentsResponse,
    DefaultError,
    Options<PostAddattachmentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postAddattachments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listReactionsToCommentQueryKey = (
  options: Options<ListReactionsToCommentData>
) => createQueryKey('listReactionsToComment', options);

/**
 * List reactions to a comment
 *
 * List reactions to a comment. Cursor based pagination is used with optional `pageSize` query params. The default value of `pageSize` is 100.
 *
 * **Note:** The result items might not have the same count as in `pageSize`. The client must keep paginating until the `links.next` is empty in the response.
 */
export const listReactionsToCommentOptions = (
  options: Options<ListReactionsToCommentData>
) =>
  queryOptions<
    ListReactionsToCommentResponse,
    DefaultError,
    ListReactionsToCommentResponse,
    ReturnType<typeof listReactionsToCommentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listReactionsToComment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listReactionsToCommentQueryKey(options),
  });

/**
 * Adds user's reaction to a comment
 *
 * Add user's reaction to a comment. Multiple different reactons are allowed, but not duplicates of the same reaction for the same user.
 */
export const addReactionToCommentMutation = (
  options?: Partial<Options<AddReactionToCommentData>>
): MutationOptions<
  AddReactionToCommentResponse2,
  DefaultError,
  Options<AddReactionToCommentData>
> => {
  const mutationOptions: MutationOptions<
    AddReactionToCommentResponse2,
    DefaultError,
    Options<AddReactionToCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addReactionToComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete users reaction to a comment
 *
 * Removes user reaction to a comment. The deletion is hard, meaning the delete operation is undoable.
 */
export const deleteReactionToCommentMutation = (
  options?: Partial<Options<DeleteReactionToCommentData>>
): MutationOptions<
  DeleteReactionToCommentResponse,
  DefaultError,
  Options<DeleteReactionToCommentData>
> => {
  const mutationOptions: MutationOptions<
    DeleteReactionToCommentResponse,
    DefaultError,
    Options<DeleteReactionToCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteReactionToComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listCompaniesQueryKey = (options?: Options<ListCompaniesData>) =>
  createQueryKey('listCompanies', options);

/**
 * List Companies
 *
 * Company user can get the list of associated companies.
 *
 * @deprecated
 */
export const listCompaniesOptions = (options?: Options<ListCompaniesData>) =>
  queryOptions<
    ListCompaniesResponse,
    DefaultError,
    ListCompaniesResponse,
    ReturnType<typeof listCompaniesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCompanies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listCompaniesQueryKey(options),
  });

export const getCompanyDetailsQueryKey = (
  options: Options<GetCompanyDetailsData>
) => createQueryKey('getCompanyDetails', options);

/**
 * Get Company Details
 *
 * API for company user/admin to get details of a company.
 *
 * @deprecated
 */
export const getCompanyDetailsOptions = (
  options: Options<GetCompanyDetailsData>
) =>
  queryOptions<
    GetCompanyDetailsResponse,
    DefaultError,
    GetCompanyDetailsResponse,
    ReturnType<typeof getCompanyDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCompanyDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCompanyDetailsQueryKey(options),
  });

/**
 * Update Company
 *
 * The company admin can update the company name, website and domains of the company.
 *
 * @deprecated
 */
export const updateCompanyMutation = (
  options?: Partial<Options<UpdateCompanyData>>
): MutationOptions<
  UpdateCompanyResponse,
  DefaultError,
  Options<UpdateCompanyData>
> => {
  const mutationOptions: MutationOptions<
    UpdateCompanyResponse,
    DefaultError,
    Options<UpdateCompanyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCompany({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove Company Email Domains
 *
 * API for company admin to remove email domains from company.
 *
 * @deprecated
 */
export const removeCompanyEmailDomainsMutation = (
  options?: Partial<Options<RemoveCompanyEmailDomainsData>>
): MutationOptions<
  RemoveCompanyEmailDomainsResponse,
  DefaultError,
  Options<RemoveCompanyEmailDomainsData>
> => {
  const mutationOptions: MutationOptions<
    RemoveCompanyEmailDomainsResponse,
    DefaultError,
    Options<RemoveCompanyEmailDomainsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeCompanyEmailDomains({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Company Email Domains
 *
 * The company admin can update the company email domains. The entries will append to the existing domains.
 *
 * @deprecated
 */
export const addCompanyEmailDomainsMutation = (
  options?: Partial<Options<AddCompanyEmailDomainsData>>
): MutationOptions<
  AddCompanyEmailDomainsResponse,
  DefaultError,
  Options<AddCompanyEmailDomainsData>
> => {
  const mutationOptions: MutationOptions<
    AddCompanyEmailDomainsResponse,
    DefaultError,
    Options<AddCompanyEmailDomainsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addCompanyEmailDomains({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Company Image
 *
 * API for company admin to update the company logo by uploading an image file.
 *
 * @deprecated
 */
export const uploadCompanyImageMutation = (
  options?: Partial<Options<UploadCompanyImageData>>
): MutationOptions<
  UploadCompanyImageResponse,
  DefaultError,
  Options<UploadCompanyImageData>
> => {
  const mutationOptions: MutationOptions<
    UploadCompanyImageResponse,
    DefaultError,
    Options<UploadCompanyImageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadCompanyImage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove Users from Company
 *
 * API for company admin to remove users from the company.
 *
 * @deprecated
 */
export const removeUsersfromCompanyMutation = (
  options?: Partial<Options<RemoveUsersfromCompanyData>>
): MutationOptions<
  RemoveUsersfromCompanyResponse,
  DefaultError,
  Options<RemoveUsersfromCompanyData>
> => {
  const mutationOptions: MutationOptions<
    RemoveUsersfromCompanyResponse,
    DefaultError,
    Options<RemoveUsersfromCompanyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeUsersfromCompany({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listUsersinaCompanyQueryKey = (
  options: Options<ListUsersinaCompanyData>
) => createQueryKey('listUsersinaCompany', options);

/**
 * List Users in a Company
 *
 * API for company user/admin to list users in the company.
 *
 * @deprecated
 */
export const listUsersinaCompanyOptions = (
  options: Options<ListUsersinaCompanyData>
) =>
  queryOptions<
    ListUsersinaCompanyResponse,
    DefaultError,
    ListUsersinaCompanyResponse,
    ReturnType<typeof listUsersinaCompanyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listUsersinaCompany({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listUsersinaCompanyQueryKey(options),
  });

/**
 * Add Users to Company
 *
 * API for company admin to add users to the company.
 *
 * @deprecated
 */
export const addUserstoCompanyMutation = (
  options?: Partial<Options<AddUserstoCompanyData>>
): MutationOptions<
  AddUserstoCompanyResponse,
  DefaultError,
  Options<AddUserstoCompanyData>
> => {
  const mutationOptions: MutationOptions<
    AddUserstoCompanyResponse,
    DefaultError,
    Options<AddUserstoCompanyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addUserstoCompany({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove User from the Company
 *
 * API for company admin to remove the specified user from the company.
 *
 * @deprecated
 */
export const removeUserfromtheCompanyMutation = (
  options?: Partial<Options<RemoveUserfromtheCompanyData>>
): MutationOptions<
  RemoveUserfromtheCompanyResponse,
  DefaultError,
  Options<RemoveUserfromtheCompanyData>
> => {
  const mutationOptions: MutationOptions<
    RemoveUserfromtheCompanyResponse,
    DefaultError,
    Options<RemoveUserfromtheCompanyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeUserfromtheCompany({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update User in the Company
 *
 * API to change the role of the user in the company.
 *
 * @deprecated
 */
export const updateUserintheCompanyMutation = (
  options?: Partial<Options<UpdateUserintheCompanyData>>
): MutationOptions<
  UpdateUserintheCompanyResponse,
  DefaultError,
  Options<UpdateUserintheCompanyData>
> => {
  const mutationOptions: MutationOptions<
    UpdateUserintheCompanyResponse,
    DefaultError,
    Options<UpdateUserintheCompanyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateUserintheCompany({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Copy the File
 *
 * Creates a copy of an existing file.
 */
export const uploadFileMutation = (
  options?: Partial<Options<UploadFileData>>
): MutationOptions<
  UploadFileResponse,
  DefaultError,
  Options<UploadFileData>
> => {
  const mutationOptions: MutationOptions<
    UploadFileResponse,
    DefaultError,
    Options<UploadFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a new export Request
 *
 * This API is used to create export Request for files in a project.
 */
export const createNewExportRequestMutation = (
  options?: Partial<Options<CreateNewExportRequestData>>
): MutationOptions<
  CreateNewExportRequestResponse,
  DefaultError,
  Options<CreateNewExportRequestData>
> => {
  const mutationOptions: MutationOptions<
    CreateNewExportRequestResponse,
    DefaultError,
    Options<CreateNewExportRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createNewExportRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getExportDetailsQueryKey = (
  options: Options<GetExportDetailsData>
) => createQueryKey('getExportDetails', options);

/**
 * Get export details
 *
 * API to fetch details of the export activities.
 */
export const getExportDetailsOptions = (
  options: Options<GetExportDetailsData>
) =>
  queryOptions<
    GetExportDetailsResponse,
    DefaultError,
    GetExportDetailsResponse,
    ReturnType<typeof getExportDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExportDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExportDetailsQueryKey(options),
  });

export const listSupported2D3dSpatialfileformatsQueryKey = (
  options?: Options<ListSupported2D3dSpatialfileformatsData>
) => createQueryKey('listSupported2d3dSpatialfileformats', options);

/**
 * List Supported 2D, 3D & Spatial file formats
 *
 * API to list supported 2D, 3D & spatial file formats.
 */
export const listSupported2D3dSpatialfileformatsOptions = (
  options?: Options<ListSupported2D3dSpatialfileformatsData>
) =>
  queryOptions<
    ListSupported2D3dSpatialfileformatsResponse,
    DefaultError,
    ListSupported2D3dSpatialfileformatsResponse,
    ReturnType<typeof listSupported2D3dSpatialfileformatsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSupported2d3dSpatialfileformats({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSupported2D3dSpatialfileformatsQueryKey(options),
  });

/**
 * Commit File Upload
 *
 * After the content upload is completed, this API is called to complete the process and create file entity in TC.<br/><br/>The md5 of the file is required in the **digest** header for Multipart upload commits.
 *
 * @deprecated
 */
export const commitFileUploadMutation = (
  options?: Partial<Options<CommitFileUploadData>>
): MutationOptions<
  unknown,
  CommitFileUploadError,
  Options<CommitFileUploadData>
> => {
  const mutationOptions: MutationOptions<
    unknown,
    CommitFileUploadError,
    Options<CommitFileUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commitFileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Initiate File upload
 *
 * **This API functionality is now supported by Package File Upload API**<br></br>These API support file uploads via presigned URL. 3 Steps include initiate upload, stream content and commit the upload process.Upload the content with the presigned url obtained from the Response of this API. Use PUT on the url from the Response to upload file content(no other parameters/headers required)<br/><br/> Multipart uploads require numberofparts and size as mandatory and it will result in list of upload URLs along with the part number. Each part in a multipart upload must be between 5 MiB (5,242,880 bytes) and 5 GiB (5,368,709,120 bytes). The last part can be smaller than 5 MiB (5,242,880 bytes). In general, part sizes should be as large as possible. Each part should be upload to corresponding part upload urls. <br/><br/> Multifile feature used to manage a collection of file objects as a single file resource is supported<br/> <br/>   The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version.<br/>  <br/>  If versionId provided in the **If-Match** header is not latest, error Response with Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &        **Error Message**: If-Match header value is not latest versionId.<br/> <br/>    If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 *
 * @deprecated
 */
export const initiateFileUploadMutation = (
  options?: Partial<Options<InitiateFileUploadData>>
): MutationOptions<
  unknown,
  InitiateFileUploadError,
  Options<InitiateFileUploadData>
> => {
  const mutationOptions: MutationOptions<
    unknown,
    InitiateFileUploadError,
    Options<InitiateFileUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await initiateFileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getActiveFileFolderSnapshotQueryKey = (
  options: Options<GetActiveFileFolderSnapshotData>
) => createQueryKey('getActiveFileFolderSnapshot', options);

/**
 * Get the latest files and folders structure
 *
 * This API retrieves the latest state of files and folders in a project.
 */
export const getActiveFileFolderSnapshotOptions = (
  options: Options<GetActiveFileFolderSnapshotData>
) =>
  queryOptions<
    GetActiveFileFolderSnapshotResponse,
    GetActiveFileFolderSnapshotError,
    GetActiveFileFolderSnapshotResponse,
    ReturnType<typeof getActiveFileFolderSnapshotQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActiveFileFolderSnapshot({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActiveFileFolderSnapshotQueryKey(options),
  });

export const getFileUploadDetailsQueryKey = (
  options: Options<GetFileUploadDetailsData>
) => createQueryKey('getFileUploadDetails', options);

/**
 * Get File Upload Details
 *
 * File upload details contains file name, parent information and uploadUrl. This api also provides the file upload status.
 */
export const getFileUploadDetailsOptions = (
  options: Options<GetFileUploadDetailsData>
) =>
  queryOptions<
    GetFileUploadDetailsResponse,
    GetFileUploadDetailsError,
    GetFileUploadDetailsResponse,
    ReturnType<typeof getFileUploadDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFileUploadDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFileUploadDetailsQueryKey(options),
  });

/**
 * Package File upload
 *
 * This API is used to initiate the file upload. The file stream should be uploaded to the upload URL received in the response with the PUT operation and no additional headers including Authorization to be sent. You can use Get File Upload Details API to check the upload status after initiating the upload.</br> </br>This API can be used to upload files and their representation formats (like  thumbnail, TRB, PDF) as a single package. The API supports multipart and multifile uploads. Multipart upload requires the multipart flag to be passed as true in FileUploadContentDto and size of the file is mandatory to be passed for multipart upload. You should replace the * in the pre-signed url received in response with the part number while uploading the parts. If the file content size is greater than 5GB,it should be uploaded as multipart. Multipart file upload is supported only for source file. You should call the upload complete API after uploading all the parts.<br></br>Multi File/ fileset (upload a set of files in an archived format) is supported by passing the fileset and path template in FileUploadContentDto. Multipart upload is supported for filesets (multifiles).<br></br>Some combinations of file types in package upload may not be supported based on the model file format. Currently Source + TRB and Source + TRB + THUMB are not supported for drawing file formats (such as DWG / DXF).<br></br> Please make sure to upload the object only once to each uploadUrl (retries can be done in case of network related failures). If several successful uploads are executed to the the same uploadUrl, the random content from one of the uploads will be picked up for the permanent storage.</br></br> **Please note that the upload will be marked as EXPIRED if file content is not uploaded within 90 minutes for the single part upload and within 30 minutes for the mutlipart upload(after the complete API is called)**
 */
export const initiateFilePackageUploadMutation = (
  options?: Partial<Options<InitiateFilePackageUploadData>>
): MutationOptions<
  InitiateFilePackageUploadResponse,
  InitiateFilePackageUploadError,
  Options<InitiateFilePackageUploadData>
> => {
  const mutationOptions: MutationOptions<
    InitiateFilePackageUploadResponse,
    InitiateFilePackageUploadError,
    Options<InitiateFilePackageUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await initiateFilePackageUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complete a multipart file upload
 *
 * Complete a multipart file upload when all parts of a multipart upload has been uploaded for a format
 */
export const completeMultipartFileUploadMutation = (
  options?: Partial<Options<CompleteMultipartFileUploadData>>
): MutationOptions<
  CompleteMultipartFileUploadResponse,
  CompleteMultipartFileUploadError,
  Options<CompleteMultipartFileUploadData>
> => {
  const mutationOptions: MutationOptions<
    CompleteMultipartFileUploadResponse,
    CompleteMultipartFileUploadError,
    Options<CompleteMultipartFileUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completeMultipartFileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFileUploadStatusQueryKey = (
  options: Options<GetFileUploadStatusData>
) => createQueryKey('getFileUploadStatus', options);

/**
 * Representation File upload status
 *
 * Upload status of a file and committing representation upload
 *
 * @deprecated
 */
export const getFileUploadStatusOptions = (
  options: Options<GetFileUploadStatusData>
) =>
  queryOptions<
    GetFileUploadStatusResponse,
    GetFileUploadStatusError,
    GetFileUploadStatusResponse,
    ReturnType<typeof getFileUploadStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFileUploadStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFileUploadStatusQueryKey(options),
  });

export const downloadUrlQueryKey = (options: Options<DownloadUrlData>) =>
  createQueryKey('downloadUrl', options);

/**
 * Download URL
 *
 * You can retrieve download URL for a single file using this action. (Part downloads supported with range headers). Use GET on the url from the Response to download file content (no other parameters/headers required)
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are downloading on the latest version.
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 */
export const downloadUrlOptions = (options: Options<DownloadUrlData>) =>
  queryOptions<
    DownloadUrlResponse2,
    DefaultError,
    DownloadUrlResponse2,
    ReturnType<typeof downloadUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await downloadUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: downloadUrlQueryKey(options),
  });

/**
 * Delete File
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const deleteFileMutation = (
  options?: Partial<Options<DeleteFileData>>
): MutationOptions<
  DeleteFileResponse,
  DefaultError,
  Options<DeleteFileData>
> => {
  const mutationOptions: MutationOptions<
    DeleteFileResponse,
    DefaultError,
    Options<DeleteFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFileDetailsQueryKey = (options: Options<GetFileDetailsData>) =>
  createQueryKey('getFileDetails', options);

/**
 * Get File Details
 *
 * This API will fetch the latest version details for the given file Id.
 *
 * To fetch a specific version information, optional query parameter __versionId__ can be specified.
 */
export const getFileDetailsOptions = (options: Options<GetFileDetailsData>) =>
  queryOptions<
    GetFileDetailsResponse,
    GetFileDetailsError,
    GetFileDetailsResponse,
    ReturnType<typeof getFileDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFileDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFileDetailsQueryKey(options),
  });

/**
 * Update File Details
 *
 * You can rename the file using this API. To move the file, change the parentId to the id of the destination folder.
 *
 * In case both parentId and name is provided, move will take precedence before rename.
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version.
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const updateFileDetailsMutation = (
  options?: Partial<Options<UpdateFileDetailsData>>
): MutationOptions<
  UpdateFileDetailsResponse,
  DefaultError,
  Options<UpdateFileDetailsData>
> => {
  const mutationOptions: MutationOptions<
    UpdateFileDetailsResponse,
    DefaultError,
    Options<UpdateFileDetailsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateFileDetails({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete alignment
 *
 * Remove alignment associated with a file.  If the **versionId** is presented for a given file version, only alignment associated with that version is removed, otherwise alignments for all version removed.
 */
export const deletealignmentMutation = (
  options?: Partial<Options<DeletealignmentData>>
): MutationOptions<
  DeletealignmentResponse,
  DefaultError,
  Options<DeletealignmentData>
> => {
  const mutationOptions: MutationOptions<
    DeletealignmentResponse,
    DefaultError,
    Options<DeletealignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deletealignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getalignmentQueryKey = (options: Options<GetalignmentData>) =>
  createQueryKey('getalignment', options);

/**
 * Get alignment
 *
 * Get the alignment for a given file. If the **versionId** is specified the alignment details for that particular version is retrieved else it will give the alignment details of the latest version.
 */
export const getalignmentOptions = (options: Options<GetalignmentData>) =>
  queryOptions<
    GetalignmentResponse2,
    DefaultError,
    GetalignmentResponse2,
    ReturnType<typeof getalignmentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getalignment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getalignmentQueryKey(options),
  });

/**
 * Create Alignment
 *
 * Create or update an alignment for a given file. It is assumed that the vectors axis and refDirection are orthonormal.
 *
 * Updates or creates alignment for the latest version of the file if versionId is not mentioned.
 */
export const createAlignmentMutation = (
  options?: Partial<Options<CreateAlignmentData>>
): MutationOptions<
  CreateAlignmentResponse,
  DefaultError,
  Options<CreateAlignmentData>
> => {
  const mutationOptions: MutationOptions<
    CreateAlignmentResponse,
    DefaultError,
    Options<CreateAlignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAlignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create alignment with matrix
 *
 * Create an alignment for a given file.  This api is deprecated.
 *
 * @deprecated
 */
export const createalignmentwithmatrixMutation = (
  options?: Partial<Options<CreatealignmentwithmatrixData>>
): MutationOptions<
  CreatealignmentwithmatrixResponse,
  DefaultError,
  Options<CreatealignmentwithmatrixData>
> => {
  const mutationOptions: MutationOptions<
    CreatealignmentwithmatrixResponse,
    DefaultError,
    Options<CreatealignmentwithmatrixData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createalignmentwithmatrix({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Checkin File
 *
 * You can checkin (release lock) on a file using this API, so its available for others to update
 */
export const checkinFileMutation = (
  options?: Partial<Options<CheckinFileData>>
): MutationOptions<
  CheckinFileResponse,
  DefaultError,
  Options<CheckinFileData>
> => {
  const mutationOptions: MutationOptions<
    CheckinFileResponse,
    DefaultError,
    Options<CheckinFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await checkinFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Checkout File
 *
 * You can checkout (lock) a file using this API
 */
export const checkoutFileMutation = (
  options?: Partial<Options<CheckoutFileData>>
): MutationOptions<
  CheckoutFileResponse,
  DefaultError,
  Options<CheckoutFileData>
> => {
  const mutationOptions: MutationOptions<
    CheckoutFileResponse,
    DefaultError,
    Options<CheckoutFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await checkoutFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFilePermissionsQueryKey = (
  options: Options<GetFilePermissionsData>
) => createQueryKey('getFilePermissions', options);

/**
 * Get File Permissions
 *
 * This API gives the access control lists (ACLs) that specify the permissions for users and groups associated with a specific file.
 */
export const getFilePermissionsOptions = (
  options: Options<GetFilePermissionsData>
) =>
  queryOptions<
    GetFilePermissionsResponse,
    GetFilePermissionsError,
    GetFilePermissionsResponse,
    ReturnType<typeof getFilePermissionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFilePermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFilePermissionsQueryKey(options),
  });

/**
 * Update File Permissions
 *
 * This API is used to add new permissions or update/remove existing permissions for a particular file given as input.<br>If any permissions exist for any users/group, they are removed (reset) and permissions provided in the request body are applied.<br>Input can be an ACL comprising lists of users and groups, with permissions set to either READ or FULL_ACCESS.<br>If the project level setting 'fullAccessIncludesPermissions' is enabled, project users with non admin rights will be able to share files.<br>Additionally, if the project level setting 'allowNonMemberPermissions' is enabled, files can be shared outside project context.<br>To represent the virtual 'All Members' group, use 'tc-groups:*' in the ACL.
 */
export const patchFilePermissionsMutation = (
  options?: Partial<Options<PatchFilePermissionsData>>
): MutationOptions<
  PatchFilePermissionsResponse,
  PatchFilePermissionsError,
  Options<PatchFilePermissionsData>
> => {
  const mutationOptions: MutationOptions<
    PatchFilePermissionsResponse,
    PatchFilePermissionsError,
    Options<PatchFilePermissionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patchFilePermissions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getprocessingstatusofaFileQueryKey = (
  options: Options<GetprocessingstatusofaFileData>
) => createQueryKey('getprocessingstatusofaFile', options);

/**
 * Get processing status of a File
 *
 * Returns the format processing status for 2D and 3D files. The valid return values are integer from 0 to 100, negative values indicate processing error.
 *
 * Supported formats are ifc, ifczip, 3dm, obj, skp, fbx, rvt, dwg, dxf, dgn, 3ds, stp, step, iges, igs, stl, doc, docx, xls, xlsx, rtf, txt, ppt, pptx, pdf, jpg, jpeg, gif, png, bmp, jpg, jpeg, gif, png, tif and tiff.
 */
export const getprocessingstatusofaFileOptions = (
  options: Options<GetprocessingstatusofaFileData>
) =>
  queryOptions<
    GetprocessingstatusofaFileResponse2,
    DefaultError,
    GetprocessingstatusofaFileResponse2,
    ReturnType<typeof getprocessingstatusofaFileQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getprocessingstatusofaFile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getprocessingstatusofaFileQueryKey(options),
  });

export const getversionsofaFileQueryKey = (
  options: Options<GetversionsofaFileData>
) => createQueryKey('getversionsofaFile', options);

/**
 * Get versions of a File
 *
 * Get versions of a File
 */
export const getversionsofaFileOptions = (
  options: Options<GetversionsofaFileData>
) =>
  queryOptions<
    GetversionsofaFileResponse,
    DefaultError,
    GetversionsofaFileResponse,
    ReturnType<typeof getversionsofaFileQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getversionsofaFile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getversionsofaFileQueryKey(options),
  });

/**
 * Create a New Folder
 *
 * You can create a new Folder using this action. It takes a JSON object containing a parent Identifier and a name, both required.
 *
 * + name (string) - The name of the folder
 *
 * + parentId (string) - parent folder's version Id
 *
 * + tags (optional) - List of Tags to be linked with folder
 */
export const createaNewFolderMutation = (
  options?: Partial<Options<CreateaNewFolderData>>
): MutationOptions<
  CreateaNewFolderResponse,
  DefaultError,
  Options<CreateaNewFolderData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNewFolderResponse,
    DefaultError,
    Options<CreateaNewFolderData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNewFolder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listItemsinaFolderbypathQueryKey = (
  options: Options<ListItemsinaFolderbypathData>
) => createQueryKey('listItemsinaFolderbypath', options);

/**
 * List Items in a Folder by path
 *
 * API returns the list of Folders and Files in the given path in the query parameter
 */
export const listItemsinaFolderbypathOptions = (
  options: Options<ListItemsinaFolderbypathData>
) =>
  queryOptions<
    ListItemsinaFolderbypathResponse,
    DefaultError,
    ListItemsinaFolderbypathResponse,
    ReturnType<typeof listItemsinaFolderbypathQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listItemsinaFolderbypath({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listItemsinaFolderbypathQueryKey(options),
  });

export const getFolderPermissionsQueryKey = (
  options: Options<GetFolderPermissionsData>
) => createQueryKey('getFolderPermissions', options);

/**
 * Get Folder Permissions
 *
 * This API gives the access control lists (ACLs) that specify the permissions for users and groups associated with a specific folder.<br>Use the query parameter <code>fields</code> with value <code>inherited</code> to include inherited permissions in addition to direct permissions.
 */
export const getFolderPermissionsOptions = (
  options: Options<GetFolderPermissionsData>
) =>
  queryOptions<
    GetFolderPermissionsResponse,
    GetFolderPermissionsError,
    GetFolderPermissionsResponse,
    ReturnType<typeof getFolderPermissionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFolderPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFolderPermissionsQueryKey(options),
  });

/**
 * Update Folder Permissions
 *
 * This API is used to add new permissions or update/remove existing permissions for a particular folder given as input.<br>If any permissions exist for any users/group, they are removed (reset) and permissions provided in the request body are applied.<br>Input can be either defaultAccess (deprecated) or an ACL comprising lists of users and groups, with permissions set to either READ or FULL_ACCESS or NO_ACCESS.<br>If the project level setting 'fullAccessIncludesPermissions' is enabled, project users with non admin rights will be able to share folders.<br>Additionally, if the project level setting 'allowNonMemberPermissions' is enabled, folders can be shared outside project context.<br>To represent the virtual 'All Members' group, use 'tc-groups:*' in the ACL.
 */
export const patchFolderPermissionsMutation = (
  options?: Partial<Options<PatchFolderPermissionsData>>
): MutationOptions<
  PatchFolderPermissionsResponse,
  PatchFolderPermissionsError,
  Options<PatchFolderPermissionsData>
> => {
  const mutationOptions: MutationOptions<
    PatchFolderPermissionsResponse,
    PatchFolderPermissionsError,
    Options<PatchFolderPermissionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patchFolderPermissions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFolderDeletionJobStatusQueryKey = (
  options: Options<GetFolderDeletionJobStatusData>
) => createQueryKey('getFolderDeletionJobStatus', options);

/**
 * Get Folder Deletion Job Status
 *
 * Gets the status of a folder deletion job.
 */
export const getFolderDeletionJobStatusOptions = (
  options: Options<GetFolderDeletionJobStatusData>
) =>
  queryOptions<
    unknown,
    GetFolderDeletionJobStatusError,
    unknown,
    ReturnType<typeof getFolderDeletionJobStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFolderDeletionJobStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFolderDeletionJobStatusQueryKey(options),
  });

/**
 * Delete Folder
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const deleteFolderMutation = (
  options?: Partial<Options<DeleteFolderData>>
): MutationOptions<
  DeleteFolderResponse,
  DefaultError,
  Options<DeleteFolderData>
> => {
  const mutationOptions: MutationOptions<
    DeleteFolderResponse,
    DefaultError,
    Options<DeleteFolderData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteFolder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFolderDetailsQueryKey = (
  options: Options<GetFolderDetailsData>
) => createQueryKey('getFolderDetails', options);

/**
 * Get Folder Details
 *
 * Get Folder Details
 */
export const getFolderDetailsOptions = (
  options: Options<GetFolderDetailsData>
) =>
  queryOptions<
    GetFolderDetailsResponse,
    GetFolderDetailsError,
    GetFolderDetailsResponse,
    ReturnType<typeof getFolderDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFolderDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFolderDetailsQueryKey(options),
  });

/**
 * Update Folder
 *
 * You can use this API to move/rename the Folder.
 *
 * To move a folder, update the parentId attribute.
 * In case both parentId and name is provided, move will take precedence before rename.
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 * You can use this API to move/rename the Folder.<br/> <br/> To move a folder, update the parentId attribute.<br/> <br/> In case both parentId and name is provided, move will take precedence before rename. <br/> <br/> The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload) <br/> <br/> If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &  **Error Message**: If-Match header value is not latest versionId. <br/> <br/> If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const updateFolderMutation = (
  options?: Partial<Options<UpdateFolderData>>
): MutationOptions<
  UpdateFolderResponse,
  UpdateFolderError,
  Options<UpdateFolderData>
> => {
  const mutationOptions: MutationOptions<
    UpdateFolderResponse,
    UpdateFolderError,
    Options<UpdateFolderData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateFolder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Folder
 *
 * Deletes the folder with the given folder ID.<br><br>- <b>Empty Folder:</b><br>  If the folder is empty, it will be deleted . The API responds with <code>204 No Content</code>.<br>- <b>Non-Empty Folder (force not set or false):</b><br>  If the folder contains items and the optional `force` query parameter is not provided or set to `false`, the deletion is rejected with an error indicating that `force=true` is required to delete non-empty folders.<br>- <b>Non-Empty Folder (force=true):</b><br>  If the folder contains items and `force` is set to `true`, the deletion is processed asynchronously. The API responds with <code>202 Accepted</code> and includes a `Location` header containing the URI to check the deletion job status. Clients can use this URI or the returned job ID to poll for completion status.
 */
export const deleteFolder2Mutation = (
  options?: Partial<Options<DeleteFolder2Data>>
): MutationOptions<
  DeleteFolder2Response,
  DeleteFolder2Error,
  Options<DeleteFolder2Data>
> => {
  const mutationOptions: MutationOptions<
    DeleteFolder2Response,
    DeleteFolder2Error,
    Options<DeleteFolder2Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteFolder2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFileFolderDetailsByNameQueryKey = (
  options: Options<GetFileFolderDetailsByNameData>
) => createQueryKey('getFileFolderDetailsByName', options);

/**
 * Get File/Folder Details By parent folder id and name
 *
 * Fetches the file/folder details as per the given parent folder id and name that user has access to. If no details present, **NOT_FOUND** exception will be thrown.
 */
export const getFileFolderDetailsByNameOptions = (
  options: Options<GetFileFolderDetailsByNameData>
) =>
  queryOptions<
    GetFileFolderDetailsByNameResponse,
    GetFileFolderDetailsByNameError,
    GetFileFolderDetailsByNameResponse,
    ReturnType<typeof getFileFolderDetailsByNameQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFileFolderDetailsByName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFileFolderDetailsByNameQueryKey(options),
  });

export const listItemsinaFolderV21QueryKey = (
  options: Options<ListItemsinaFolderV21Data>
) => createQueryKey('listItemsinaFolderV21', options);

/**
 * List Items in a Folder
 *
 * List Items in a Folder
 */
export const listItemsinaFolderV21Options = (
  options: Options<ListItemsinaFolderV21Data>
) =>
  queryOptions<
    ListItemsinaFolderV21Response,
    DefaultError,
    ListItemsinaFolderV21Response,
    ReturnType<typeof listItemsinaFolderV21QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listItemsinaFolderV21({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listItemsinaFolderV21QueryKey(options),
  });

/**
 * Remove any existing Folder Permission
 *
 * This API allows to removes specified given permission to given user/group and recomputes permission for actor based on user roles and default permission.
 * It takes optional cascade field to delete permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 *
 * This API takes propagation flag and a list of Permissions as a Request Body, each permission has following fields
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * Example : <br/>
 * {<br/>
 * "cascade": "true",<br/>
 * "permissions": [<br/>
 * {<br/>
 * "id": "0Z-OMo67VtY",<br/>
 * "type": "USER"<br/>
 * },<br/>
 * {<br/>
 * "id": "swO2L9AqeT0",<br/>
 * "type": "GROUP"<br/>
 * }<br/>
 * ]<br/>
 * }<br/>
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 *
 * @deprecated
 */
export const removeanyexistingFolderPermissionMutation = (
  options?: Partial<Options<RemoveanyexistingFolderPermissionData>>
): MutationOptions<
  RemoveanyexistingFolderPermissionResponse,
  DefaultError,
  Options<RemoveanyexistingFolderPermissionData>
> => {
  const mutationOptions: MutationOptions<
    RemoveanyexistingFolderPermissionResponse,
    DefaultError,
    Options<RemoveanyexistingFolderPermissionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeanyexistingFolderPermission({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFolderPermissions2QueryKey = (
  options: Options<GetFolderPermissions2Data>
) => createQueryKey('getFolderPermissions2', options);

/**
 * Get Folder Permissions
 *
 * This API gives a list of Permissions that are applied to a given folder
 *
 * @deprecated
 */
export const getFolderPermissions2Options = (
  options: Options<GetFolderPermissions2Data>
) =>
  queryOptions<
    GetFolderPermissions2Response,
    DefaultError,
    GetFolderPermissions2Response,
    ReturnType<typeof getFolderPermissions2QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFolderPermissions2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFolderPermissions2QueryKey(options),
  });

/**
 * Update existing Folder Permission
 *
 * This API allows to update existing folder Permissions or add permissions for new users/groups. It can also be used to reset the default permission.
 * It takes optional cascade field to update permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 * This API takes default permission, propagation flag and a list of Permissions.
 * Each permission has following fields:
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * - permission
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 * Inheritance flag will be set to false by default.
 *
 * @deprecated
 */
export const updateexistingFolderPermissionMutation = (
  options?: Partial<Options<UpdateexistingFolderPermissionData>>
): MutationOptions<
  UpdateexistingFolderPermissionResponse,
  DefaultError,
  Options<UpdateexistingFolderPermissionData>
> => {
  const mutationOptions: MutationOptions<
    UpdateexistingFolderPermissionResponse,
    DefaultError,
    Options<UpdateexistingFolderPermissionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateexistingFolderPermission({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add a New Folder Permission
 *
 * This API allows to create a new folder Permission for users/groups. If any permissions exist for any users/group, they are removed (reset) and permissions provided in Request body are applied.
 * It can also be used to reset the default permission.
 * It takes optional cascade field to add permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 *
 * This API takes a default permission, propagation flag and a list of Permissions.
 * Each permission has following fields:
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * - permission
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 * Inheritance flag will be set to false by default.
 *
 * @deprecated
 */
export const addaNewFolderPermissionMutation = (
  options?: Partial<Options<AddaNewFolderPermissionData>>
): MutationOptions<
  AddaNewFolderPermissionResponse,
  DefaultError,
  Options<AddaNewFolderPermissionData>
> => {
  const mutationOptions: MutationOptions<
    AddaNewFolderPermissionResponse,
    DefaultError,
    Options<AddaNewFolderPermissionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addaNewFolderPermission({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getversionsofaFolderQueryKey = (
  options: Options<GetversionsofaFolderData>
) => createQueryKey('getversionsofaFolder', options);

/**
 * Get versions of a Folder
 *
 * Get versions of a Folder
 */
export const getversionsofaFolderOptions = (
  options: Options<GetversionsofaFolderData>
) =>
  queryOptions<
    GetversionsofaFolderResponse,
    DefaultError,
    GetversionsofaFolderResponse,
    ReturnType<typeof getversionsofaFolderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getversionsofaFolder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getversionsofaFolderQueryKey(options),
  });

export const listGroupsinaprojectQueryKey = (
  options: Options<ListGroupsinaprojectData>
) => createQueryKey('listGroupsinaproject', options);

/**
 * List Groups in a project
 *
 * List Groups in a project
 */
export const listGroupsinaprojectOptions = (
  options: Options<ListGroupsinaprojectData>
) =>
  queryOptions<
    ListGroupsinaprojectResponse,
    DefaultError,
    ListGroupsinaprojectResponse,
    ReturnType<typeof listGroupsinaprojectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listGroupsinaproject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listGroupsinaprojectQueryKey(options),
  });

/**
 * Create a New Group
 *
 * You can create a new group using this action. You need to provide a project id in which the group should be created and group name
 */
export const createaNewGroupMutation = (
  options?: Partial<Options<CreateaNewGroupData>>
): MutationOptions<
  CreateaNewGroupResponse,
  DefaultError,
  Options<CreateaNewGroupData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNewGroupResponse,
    DefaultError,
    Options<CreateaNewGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNewGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Group
 *
 * You can use this API to delete a Group.
 */
export const deleteGroupMutation = (
  options?: Partial<Options<DeleteGroupData>>
): MutationOptions<
  DeleteGroupResponse,
  DefaultError,
  Options<DeleteGroupData>
> => {
  const mutationOptions: MutationOptions<
    DeleteGroupResponse,
    DefaultError,
    Options<DeleteGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getGroupDetailsQueryKey = (
  options: Options<GetGroupDetailsData>
) => createQueryKey('getGroupDetails', options);

/**
 * Get Group Details
 *
 * Get the details of a group.
 */
export const getGroupDetailsOptions = (options: Options<GetGroupDetailsData>) =>
  queryOptions<
    GetGroupDetailsResponse,
    DefaultError,
    GetGroupDetailsResponse,
    ReturnType<typeof getGroupDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGroupDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGroupDetailsQueryKey(options),
  });

/**
 * Rename Group
 *
 * You can use this API to rename the Group.
 */
export const renameGroupMutation = (
  options?: Partial<Options<RenameGroupData>>
): MutationOptions<
  RenameGroupResponse,
  DefaultError,
  Options<RenameGroupData>
> => {
  const mutationOptions: MutationOptions<
    RenameGroupResponse,
    DefaultError,
    Options<RenameGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await renameGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete users from group
 *
 * Use this API to remove users from an existing group <br/>
 * [<br/>
 * {<br/>
 * "id": "Dyfw481f299"<br/>
 * },<br/>
 * {<br/>
 * "id": "T2P8S-tqF7s"<br/>
 * }<br/>
 * ]
 */
export const deleteusersfromgroupMutation = (
  options?: Partial<Options<DeleteusersfromgroupData>>
): MutationOptions<
  DeleteusersfromgroupResponse,
  DefaultError,
  Options<DeleteusersfromgroupData>
> => {
  const mutationOptions: MutationOptions<
    DeleteusersfromgroupResponse,
    DefaultError,
    Options<DeleteusersfromgroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteusersfromgroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listUsersinaGroupQueryKey = (
  options: Options<ListUsersinaGroupData>
) => createQueryKey('listUsersinaGroup', options);

/**
 * List Users in a Group
 *
 * API returns the list of Users in the given groupId. Only Active and Pending users will be displayed. Removed users will not be listed.
 */
export const listUsersinaGroupOptions = (
  options: Options<ListUsersinaGroupData>
) =>
  queryOptions<
    ListUsersinaGroupResponse,
    DefaultError,
    ListUsersinaGroupResponse,
    ReturnType<typeof listUsersinaGroupQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listUsersinaGroup({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listUsersinaGroupQueryKey(options),
  });

/**
 * Add users to group
 *
 * Use this API to add users to an existing group
 */
export const adduserstogroupMutation = (
  options?: Partial<Options<AdduserstogroupData>>
): MutationOptions<
  AdduserstogroupResponse,
  DefaultError,
  Options<AdduserstogroupData>
> => {
  const mutationOptions: MutationOptions<
    AdduserstogroupResponse,
    DefaultError,
    Options<AdduserstogroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await adduserstogroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listlinkedentitiesforobjectsQueryKey = (
  options?: Options<ListlinkedentitiesforobjectsData>
) => createQueryKey('listlinkedentitiesforobjects', options);

/**
 * List linked entities for objects
 *
 * This API returns the list of links based on the version Id of the 3d model and the object Id (or object source Id). Either id or versionId parameter must be provided.
 */
export const listlinkedentitiesforobjectsOptions = (
  options?: Options<ListlinkedentitiesforobjectsData>
) =>
  queryOptions<
    ListlinkedentitiesforobjectsResponse,
    DefaultError,
    ListlinkedentitiesforobjectsResponse,
    ReturnType<typeof listlinkedentitiesforobjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listlinkedentitiesforobjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listlinkedentitiesforobjectsQueryKey(options),
  });

/**
 * Create object link
 *
 * This API creates a single object link. New Target TOPIC is added which accepts Topic uuid as Id
 */
export const createobjectlinkMutation = (
  options?: Partial<Options<CreateobjectlinkData>>
): MutationOptions<
  CreateobjectlinkResponse,
  DefaultError,
  Options<CreateobjectlinkData>
> => {
  const mutationOptions: MutationOptions<
    CreateobjectlinkResponse,
    DefaultError,
    Options<CreateobjectlinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createobjectlink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk create object links
 *
 * This api bulk creates a collection of object links. New Target TOPIC is added which accepts Topic uuid as Id
 */
export const bulkcreateobjectlinksMutation = (
  options?: Partial<Options<BulkcreateobjectlinksData>>
): MutationOptions<
  BulkcreateobjectlinksResponse,
  DefaultError,
  Options<BulkcreateobjectlinksData>
> => {
  const mutationOptions: MutationOptions<
    BulkcreateobjectlinksResponse,
    DefaultError,
    Options<BulkcreateobjectlinksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkcreateobjectlinks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listlinksforthegiventargetentityQueryKey = (
  options: Options<ListlinksforthegiventargetentityData>
) => createQueryKey('listlinksforthegiventargetentity', options);

/**
 * List links for the given target entity
 *
 * This API returns the set of object links for a given target. For versioned target, either id or versionId must be provided. For ISSUE target, contextId is required.
 */
export const listlinksforthegiventargetentityOptions = (
  options: Options<ListlinksforthegiventargetentityData>
) =>
  queryOptions<
    ListlinksforthegiventargetentityResponse,
    DefaultError,
    ListlinksforthegiventargetentityResponse,
    ReturnType<typeof listlinksforthegiventargetentityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listlinksforthegiventargetentity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listlinksforthegiventargetentityQueryKey(options),
  });

/**
 * Delete an object link
 *
 * Delete an object link
 */
export const deleteaobjectlinkMutation = (
  options?: Partial<Options<DeleteaobjectlinkData>>
): MutationOptions<
  DeleteaobjectlinkResponse,
  DefaultError,
  Options<DeleteaobjectlinkData>
> => {
  const mutationOptions: MutationOptions<
    DeleteaobjectlinkResponse,
    DefaultError,
    Options<DeleteaobjectlinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteaobjectlink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update object links
 *
 * Update object links
 */
export const updateobjectlinksMutation = (
  options?: Partial<Options<UpdateobjectlinksData>>
): MutationOptions<
  UpdateobjectlinksResponse,
  DefaultError,
  Options<UpdateobjectlinksData>
> => {
  const mutationOptions: MutationOptions<
    UpdateobjectlinksResponse,
    DefaultError,
    Options<UpdateobjectlinksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateobjectlinks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listallProjectsQueryKey = (
  options?: Options<ListallProjectsData>
) => createQueryKey('listallProjects', options);

/**
 * List all Projects
 *
 * API to list all the projects for the user. Folders count metric includes the root folder as well.
 */
export const listallProjectsOptions = (
  options?: Options<ListallProjectsData>
) =>
  queryOptions<
    ListallProjectsResponse,
    DefaultError,
    ListallProjectsResponse,
    ReturnType<typeof listallProjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallProjectsQueryKey(options),
  });

/**
 * Create a New Project
 *
 * You may create a new Project using this action.
 *
 * TC supports max length of 255 characters for project names. Names are validated according to OS supported rules, so ones that contain non-printable ascii or with special meaning will be rejected by the API (Ex: "..", "PRN", "/")
 */
export const createaNewProjectMutation = (
  options?: Partial<Options<CreateaNewProjectData>>
): MutationOptions<
  CreateaNewProjectResponse,
  DefaultError,
  Options<CreateaNewProjectData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNewProjectResponse,
    DefaultError,
    Options<CreateaNewProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNewProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Request access to projects the user is not part of.
 *
 * This API allows users to request access to project they are not currently part of by triggering an email to project admins.
 */
export const requestProjectAccessMutation = (
  options?: Partial<Options<RequestProjectAccessData>>
): MutationOptions<
  unknown,
  DefaultError,
  Options<RequestProjectAccessData>
> => {
  const mutationOptions: MutationOptions<
    unknown,
    DefaultError,
    Options<RequestProjectAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestProjectAccess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Clone project from existing project
 *
 * This API facilitates the creation of a new project by cloning an existing one.
 * API supports cloning settings, users, groups, folders and permissions of an
 * existing project. It generates a request to clone the given project and returns
 * the details of the clone process. Status of the clone process can be tracked
 * using the GET project clone details API.
 *
 *
 * The 'include' field in the request body indicate the items to be included in
 * clone. The selection of these items could be done in any manner. Only those
 * items that are selected will be included in clone.
 *
 *
 * However, there is also a special scenario
 *
 *
 * `*` => implicitly includes all options (folders, users, groups, settings and folderPermissions)
 *
 *
 * Examples on how different values in 'include' control the clone behavior
 *
 *
 * - folders + users => folders and users alone will be cloned
 *
 * - folders + groups => folders and groups alone will be cloned
 *
 * - folders + users + settings => folders, users and settings alone will be cloned
 *
 * - folders + folderPermissions => folders and default folder permissions will be cloned
 *
 * - folders + users + folderPermissions => folders, users, default folder permissions and user permissions in folder level will be cloned
 *
 * - folders + groups + folderPermissions => folders, groups, default default permissions and group permissions in folder level will be cloned.
 *
 * - folders + folderPermissions + settings => folders, folder default permissions and settings will be cloned
 *
 * - `*` => all items (folders, users, groups, respective folder permissions and settings) will be cloned
 *
 * - settings + users + groups + folderPermissions =>   settings, users and groups will be cloned
 *
 * `Permission level required:` Only project admins can perform the project clone operation
 */
export const cloneProjectMutation = (
  options?: Partial<Options<CloneProjectData>>
): MutationOptions<
  CloneProjectResponse,
  DefaultError,
  Options<CloneProjectData>
> => {
  const mutationOptions: MutationOptions<
    CloneProjectResponse,
    DefaultError,
    Options<CloneProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cloneProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectCloneDetailsQueryKey = (
  options: Options<GetProjectCloneDetailsData>
) => createQueryKey('getProjectCloneDetails', options);

/**
 * Get the details of project clone
 *
 * API to fetch details of the project clone. The response will contain the id of the cloned project (inside the `result` object) in case of successful clone, or will contain information about the reason for failure in case of clone failure.
 *
 * `Permission level required:` This API can be accessed only by the user who initiated the project clone
 */
export const getProjectCloneDetailsOptions = (
  options: Options<GetProjectCloneDetailsData>
) =>
  queryOptions<
    GetProjectCloneDetailsResponse,
    DefaultError,
    GetProjectCloneDetailsResponse,
    ReturnType<typeof getProjectCloneDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectCloneDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectCloneDetailsQueryKey(options),
  });

export const listAllProjectsMiniQueryKey = (
  options?: Options<ListAllProjectsMiniData>
) => createQueryKey('listAllProjectsMini', options);

/**
 * List all projects with minimal information
 *
 * This API is used to fetch the project details of logged-in user which contains following details:projectId, role of logged-in user in the project and the list of group identifiers. Can be used as an efficient way to fetch a list of projects user is member of for making e.g. autorization decision.
 */
export const listAllProjectsMiniOptions = (
  options?: Options<ListAllProjectsMiniData>
) =>
  queryOptions<
    ListAllProjectsMiniResponse,
    DefaultError,
    ListAllProjectsMiniResponse,
    ReturnType<typeof listAllProjectsMiniQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAllProjectsMini({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAllProjectsMiniQueryKey(options),
  });

/**
 * Delete Project
 *
 * API to delete a project
 */
export const deleteProjectMutation = (
  options?: Partial<Options<DeleteProjectData>>
): MutationOptions<
  DeleteProjectResponse,
  DefaultError,
  Options<DeleteProjectData>
> => {
  const mutationOptions: MutationOptions<
    DeleteProjectResponse,
    DefaultError,
    Options<DeleteProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectDetailsQueryKey = (
  options: Options<GetProjectDetailsData>
) => createQueryKey('getProjectDetails', options);

/**
 * Get Project Details
 *
 * API to fetch details of a project.Folders count metric includes the root folder as well.
 *
 * Note : An empty object for "license" property indicates that the project does not have any license mapped with it in ECom Enforcement rules.
 */
export const getProjectDetailsOptions = (
  options: Options<GetProjectDetailsData>
) =>
  queryOptions<
    GetProjectDetailsResponse,
    DefaultError,
    GetProjectDetailsResponse,
    ReturnType<typeof getProjectDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectDetailsQueryKey(options),
  });

/**
 * Update Project
 *
 * The following properties can be updated using this request (any field can be updated individually)
 * * name
 * * address
 * * description
 * * startDate
 * * endDate
 * * lastVisitedOn
 * * crs
 *
 * *The date can be reset to NULL if you pass empty string as input for startDate and endDate*
 *
 * **Note :** For startDate and endDate, only the date will be considered from the timestamp, not the time or timezone.
 */
export const updateProjectMutation = (
  options?: Partial<Options<UpdateProjectData>>
): MutationOptions<
  UpdateProjectResponse,
  DefaultError,
  Options<UpdateProjectData>
> => {
  const mutationOptions: MutationOptions<
    UpdateProjectResponse,
    DefaultError,
    Options<UpdateProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Project Image
 *
 * API to set an image for the project <br> Supported types are **jpg,jpeg,gif,png,tif,tiff,bmp**
 */
export const uploadProjectImageMutation = (
  options?: Partial<Options<UploadProjectImageData>>
): MutationOptions<
  UploadProjectImageResponse,
  DefaultError,
  Options<UploadProjectImageData>
> => {
  const mutationOptions: MutationOptions<
    UploadProjectImageResponse,
    DefaultError,
    Options<UploadProjectImageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadProjectImage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectlicensedetailsQueryKey = (
  options: Options<GetProjectlicensedetailsData>
) => createQueryKey('getProjectlicensedetails', options);

/**
 * Get Project license details
 *
 * API to get license details for a project.
 */
export const getProjectlicensedetailsOptions = (
  options: Options<GetProjectlicensedetailsData>
) =>
  queryOptions<
    GetProjectlicensedetailsResponse,
    DefaultError,
    GetProjectlicensedetailsResponse,
    ReturnType<typeof getProjectlicensedetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectlicensedetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectlicensedetailsQueryKey(options),
  });

/**
 * Update Project license
 *
 * API to update the license assigned to a project by license id. This API is accessible for all the project admins to update the project's license using one of their active licenses. Additionally, site admins can utilize this API to update a project's license on behalf of a user, using any active license assigned to that user by passing subscriptionId in the request body.
 */
export const updateProjectLicenseDetailsMutation = (
  options?: Partial<Options<UpdateProjectLicenseDetailsData>>
): MutationOptions<
  unknown,
  DefaultError,
  Options<UpdateProjectLicenseDetailsData>
> => {
  const mutationOptions: MutationOptions<
    unknown,
    DefaultError,
    Options<UpdateProjectLicenseDetailsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProjectLicenseDetails({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectMetricsQueryKey = (
  options: Options<GetProjectMetricsData>
) => createQueryKey('getProjectMetrics', options);

/**
 * Get Project Metrics
 *
 * API to fetch metrics of a project. Folders count metric includes the root folder as well.
 */
export const getProjectMetricsOptions = (
  options: Options<GetProjectMetricsData>
) =>
  queryOptions<
    GetProjectMetricsResponse,
    DefaultError,
    GetProjectMetricsResponse,
    ReturnType<typeof getProjectMetricsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectMetricsQueryKey(options),
  });

export const getProjectSyncObjectsQueryKey = (
  options: Options<GetProjectSyncObjectsData>
) => createQueryKey('getProjectSyncObjects', options);

/**
 * Get project content changes since last time
 *
 * Fetch the changes in the project content happend after the sync cursor value proved in the `status` parameter.
 * The API allows to fetch changes in project files and folders. Each change represents a new version of the file or folder. Changes are ordered by the time. The API can be thought of as a stream of change events, client fetches events from the stream using a cursor (skipToken) that represents a position in the stream. If skipToken is not provided then events are fetched from the beginning of the project history, otherwise only events that happen after the given cursor are returned. The API allows to implement efficient incremental synchronisation (or cache invalidation) for the project file system on the client side.
 */
export const getProjectSyncObjectsOptions = (
  options: Options<GetProjectSyncObjectsData>
) =>
  queryOptions<
    GetProjectSyncObjectsResponse,
    GetProjectSyncObjectsError,
    GetProjectSyncObjectsResponse,
    ReturnType<typeof getProjectSyncObjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectSyncObjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectSyncObjectsQueryKey(options),
  });

export const listrolesavailableinprojectQueryKey = (
  options: Options<ListrolesavailableinprojectData>
) => createQueryKey('listrolesavailableinproject', options);

/**
 * List roles available in project
 *
 * API to list the roles available in a project.
 */
export const listrolesavailableinprojectOptions = (
  options: Options<ListrolesavailableinprojectData>
) =>
  queryOptions<
    ListrolesavailableinprojectResponse,
    DefaultError,
    ListrolesavailableinprojectResponse,
    ReturnType<typeof listrolesavailableinprojectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listrolesavailableinproject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listrolesavailableinprojectQueryKey(options),
  });

export const getProjectsettingsQueryKey = (
  options: Options<GetProjectsettingsData>
) => createQueryKey('getProjectsettings', options);

/**
 * Get Project settings
 *
 * API to List all the project specific settings.
 */
export const getProjectsettingsOptions = (
  options: Options<GetProjectsettingsData>
) =>
  queryOptions<
    GetProjectsettingsResponse,
    DefaultError,
    GetProjectsettingsResponse,
    ReturnType<typeof getProjectsettingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectsettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectsettingsQueryKey(options),
  });

/**
 * Update Project Settings
 *
 * This API will set all settings related to project. Generally sets sync,notifications,unit settings. "ALLOW_AUTO_CHECKOUT" is the default value in case if sync mode is not given in sync settings.
 *
 * **Unit Settings :**
 * API allows to reset all the values to metric/imperial/USSurveyFeet if unitsystem is the only attribute in the api Request. Custom unit system allows setting mix and match values.
 *
 * eg: "unitSettings": {
 * "unitsystem": "metric”
 * }
 *
 * **Acceptable values for unitsettings :**
 *
 * <p>Decimal precisions - (0, 0.1, 0.01, 0.001, 0.0001, 0.00001, 0.000001, 0.0000001, 0.00000001)<br>
 * Fractional precisions -(1/2,1/4,1/8,1/16,1/32,1/64)<br></p>
 *
 * unitsystem - (metric, imperial, USSurveyFeet, custom)
 * <p align="right"><i>Defaults are in bold</i></p>
 * <table>
 * <tr>
 * <td></td>
 * <th>metric</th>
 * <th>imperial</th>
 * <th>USSurveyFeet</th>
 * </tr>
 * <tr>
 * <td>lengthunit</td>
 * <td><b>mm</b> - <b>0</b>
 * <br/>cm - <b>0.1</b>
 * <br/>m - <b>0.01</b>
 * <br/>km  - <b>0.001</b></td>
 * <td><b>in</b> - <b>0.1</b>
 * <br/>ft-in - <b>1/4</b>
 * <br/>ft - <b>0.01</b>
 * <br/>yd - <b>0.01</b>
 * <br/>mi - <b>0.001</b>
 * <br/>usft - <b>0.001</b></td>
 * <td>sIN - <b>0.1</b>
 * <br/><b>sFT</b> - <b>0.01</b>
 * <br/>sYD - <b>0.01</b>
 * <br/>sMI - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>lengthmeasurementunit</td>
 * <td><b>mm</b> - <b>0</b>
 * <br/>cm - <b>0.1</b>
 * <br/>m - <b>0.01</b>
 * <br/>km - <b>0.001</b></td>
 * <td><b>in</b> - <b>0.1</b>
 * <br/>ft-in - <b>1/4</b>
 * <br/>ft - <b>0.01</b>
 * <br/>yd - <b>0.01</b>
 * <br/>mi - <b>0.001</b></td>
 * <td>sIN - <b>0.1</b>
 * <br/><b>sFT</b> - <b>0.01</b>
 * <br/>sYD - <b>0.01</b>
 * <br/>sMI - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>areaunit</td>
 * <td>mm2 - <b>0</b>
 * <br/>cm2 - <b>0.1</b>
 * <br/><b>m2</b> - <b>0.01</b>
 * <br/>ha - <b>0.001</b></td>
 * <td>in2 - <b>0.1</b>
 * <br/><b>ft2</b> - <b>0.01</b>
 * <br/>yd2 - <b>0.001</b>
 * <br/>ac - <b>0.001</b>
 * <br/>mi2 - <b>0.001</b>
 * <br/>usft2 - <b>0.001</b>
 * <br/>usyd2 - <b>0.001</b></td>
 * <td>in2 - <b>0.1</b>
 * <br/><b>ft2</b> - <b>0.01</b>
 * <br/>yd2 - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>volumeunit</td>
 * <td>mm3 - <b>0</b>
 * <br/>cm3 - <b>0.1</b>
 * <br/><b>m3</b> - <b>0.01</b></td>
 * <td>in3 - <b>0.1</b>
 * <br/>ft3 - <b>0.01</b>
 * <br/><b>yd3</b> - <b>0.001</b>
 * <br/>usft3 - <b>0.001</b>
 * <br/>usyd3 - <b>0.001</b>
 * <br/>acft - <b>0.001</b>
 * <br/>usacft - <b>0.001</b></td>
 * <td>in3 - <b>0.1</b>
 * <br/>ft3 - <b>0.01</b>
 * <br/><b>yd3</b> - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>weightunit</td>
 * <td>mg - <b>0</b>
 * <br/>g - <b>0.1</b>
 * <br/>kg - <b>0.01</b>
 * <br/><b>t</b> - <b>0.001</b></td>
 * <td>oz - <b>0.1</b>
 * <br/>lb - <b>0.01</b>
 * <br/><b>ton</b> - <b>0.001</b>
 * <br/>stone - <b>0.001</b></td>
 * <td>oz - <b>0.1</b>
 * <br/>lb - <b>0.01</b>
 * <br/><b>ton</b> - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>angularunit</td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * </tr>
 * </table>
 */
export const updateProjectSettingsMutation = (
  options?: Partial<Options<UpdateProjectSettingsData>>
): MutationOptions<
  unknown,
  DefaultError,
  Options<UpdateProjectSettingsData>
> => {
  const mutationOptions: MutationOptions<
    unknown,
    DefaultError,
    Options<UpdateProjectSettingsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProjectSettings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectSyncStatusQueryKey = (
  options: Options<GetProjectSyncStatusData>
) => createQueryKey('getProjectSyncStatus', options);

/**
 * Get project content sync cursor.
 *
 * Returns the project content sync cursor. This sync cursor is exected to be used together with the `ObjectSync` API to detect changes in the project content and do the incremental sync.
 */
export const getProjectSyncStatusOptions = (
  options: Options<GetProjectSyncStatusData>
) =>
  queryOptions<
    GetProjectSyncStatusResponse,
    DefaultError,
    GetProjectSyncStatusResponse,
    ReturnType<typeof getProjectSyncStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectSyncStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectSyncStatusQueryKey(options),
  });

export const listallUsersinprojectQueryKey = (
  options: Options<ListallUsersinprojectData>
) => createQueryKey('listallUsersinproject', options);

/**
 * List all Users in project
 *
 * API to fetch list of users in a project
 */
export const listallUsersinprojectOptions = (
  options: Options<ListallUsersinprojectData>
) =>
  queryOptions<
    ListallUsersinprojectResponse,
    DefaultError,
    ListallUsersinprojectResponse,
    ReturnType<typeof listallUsersinprojectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallUsersinproject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallUsersinprojectQueryKey(options),
  });

/**
 * Add/Invite Users to project
 *
 *  This API allows you to invite new and existing users to a project.
 *
 * Email address and role are required to add users to project.
 *
 * The Response will be minimal for user not in Trimble Connect and for the users in the Trimble Connect there will be complete Response.
 *
 * In mininal Response there will be only three fields in the Response body **Email** , **status** , **role**
 */
export const addInviteUserstoprojectMutation = (
  options?: Partial<Options<AddInviteUserstoprojectData>>
): MutationOptions<
  AddInviteUserstoprojectResponse,
  DefaultError,
  Options<AddInviteUserstoprojectData>
> => {
  const mutationOptions: MutationOptions<
    AddInviteUserstoprojectResponse,
    DefaultError,
    Options<AddInviteUserstoprojectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addInviteUserstoproject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove user
 *
 * API to remove a particular user from the project
 */
export const removeuserMutation = (
  options?: Partial<Options<RemoveuserData>>
): MutationOptions<
  RemoveuserResponse,
  DefaultError,
  Options<RemoveuserData>
> => {
  const mutationOptions: MutationOptions<
    RemoveuserResponse,
    DefaultError,
    Options<RemoveuserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeuser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectUserDetailsQueryKey = (
  options: Options<GetProjectUserDetailsData>
) => createQueryKey('getProjectUserDetails', options);

/**
 * Get User Details
 *
 * API to get user details by project Id and  Trimble Connect user identifier(userId). Use `me` alias (`/projects/{projectId}/users/me`) to get details about the user associated with the passed access token.
 */
export const getProjectUserDetailsOptions = (
  options: Options<GetProjectUserDetailsData>
) =>
  queryOptions<
    GetProjectUserDetailsResponse,
    DefaultError,
    GetProjectUserDetailsResponse,
    ReturnType<typeof getProjectUserDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectUserDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectUserDetailsQueryKey(options),
  });

/**
 * Update User role
 *
 * API to update the role of user in a project
 */
export const updateUserroleMutation = (
  options?: Partial<Options<UpdateUserroleData>>
): MutationOptions<
  UpdateUserroleResponse,
  DefaultError,
  Options<UpdateUserroleData>
> => {
  const mutationOptions: MutationOptions<
    UpdateUserroleResponse,
    DefaultError,
    Options<UpdateUserroleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateUserrole({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAvailableRegionsQueryKey = (
  options?: Options<GetAvailableRegionsData>
) => createQueryKey('getAvailableRegions', options);

/**
 * Get Available Regions
 *
 * Get Available Regions
 */
export const getAvailableRegionsOptions = (
  options?: Options<GetAvailableRegionsData>
) =>
  queryOptions<
    GetAvailableRegionsResponse2,
    DefaultError,
    GetAvailableRegionsResponse2,
    ReturnType<typeof getAvailableRegionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAvailableRegions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAvailableRegionsQueryKey(options),
  });

export const listallReleasesQueryKey = (
  options: Options<ListallReleasesData>
) => createQueryKey('listallReleases', options);

/**
 * List all Releases
 *
 * This API will fetch all the releases for the project. To fetch specific release status the optional __status__ query parameter can be used.
 */
export const listallReleasesOptions = (options: Options<ListallReleasesData>) =>
  queryOptions<
    ListallReleasesResponse,
    DefaultError,
    ListallReleasesResponse,
    ReturnType<typeof listallReleasesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallReleases({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallReleasesQueryKey(options),
  });

/**
 * Create a New Release
 *
 * API to create a new Release.
 *
 * + name (string) - Name of the release
 *
 * + dueDate (timestamp) - Due date for the release
 *
 * + projectId (string) - Project Identifier
 *
 * Following fields can be optionally specified while creating the release:
 *
 * + notes (string) - notes for the release
 *
 * + recipients (array of users/groups) - recipients of the release
 */
export const createaNewReleaseMutation = (
  options?: Partial<Options<CreateaNewReleaseData>>
): MutationOptions<
  CreateaNewReleaseResponse,
  DefaultError,
  Options<CreateaNewReleaseData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNewReleaseResponse,
    DefaultError,
    Options<CreateaNewReleaseData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNewRelease({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Download files in release
 *
 * You can download the file versions associated to a release. List of versionIds should be passed in the Request. If multiple file versions passed in the Request body, the output will be zip file format. If no versions passed in the Request body (i.e empty array),  all file versions associated to the release will be downloaded
 */
export const downloadfilesinreleaseMutation = (
  options?: Partial<Options<DownloadfilesinreleaseData>>
): MutationOptions<
  unknown,
  DefaultError,
  Options<DownloadfilesinreleaseData>
> => {
  const mutationOptions: MutationOptions<
    unknown,
    DefaultError,
    Options<DownloadfilesinreleaseData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await downloadfilesinrelease({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Release
 *
 * API to delete a release
 */
export const deleteReleaseMutation = (
  options?: Partial<Options<DeleteReleaseData>>
): MutationOptions<
  DeleteReleaseResponse,
  DefaultError,
  Options<DeleteReleaseData>
> => {
  const mutationOptions: MutationOptions<
    DeleteReleaseResponse,
    DefaultError,
    Options<DeleteReleaseData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteRelease({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getReleaseDetailsQueryKey = (
  options: Options<GetReleaseDetailsData>
) => createQueryKey('getReleaseDetails', options);

/**
 * Get Release Details
 *
 * Get Release Details
 */
export const getReleaseDetailsOptions = (
  options: Options<GetReleaseDetailsData>
) =>
  queryOptions<
    GetReleaseDetailsResponse,
    DefaultError,
    GetReleaseDetailsResponse,
    ReturnType<typeof getReleaseDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReleaseDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReleaseDetailsQueryKey(options),
  });

/**
 * Edit Release
 *
 * This API allows you to update the following properties of the Release:
 *
 * - name
 *
 * - dueDate
 *
 * - notes
 *
 * - recipients
 *
 * - status
 *
 * To send the release to recipients, the __status__ property has to be set as "SENT" in the Request body.
 */
export const editReleaseMutation = (
  options?: Partial<Options<EditReleaseData>>
): MutationOptions<
  EditReleaseResponse,
  DefaultError,
  Options<EditReleaseData>
> => {
  const mutationOptions: MutationOptions<
    EditReleaseResponse,
    DefaultError,
    Options<EditReleaseData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await editRelease({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove files
 *
 * You can remove files from release using this API. This api takes below json as request body <br/>
 * [<br/>
 * {<br/>
 * "id": "woC32em2Fb0",<br/>
 * "type": "FILE"<br/>
 * }<br/>
 * ]<br/>
 */
export const removefilesMutation = (
  options?: Partial<Options<RemovefilesData>>
): MutationOptions<
  RemovefilesResponse,
  DefaultError,
  Options<RemovefilesData>
> => {
  const mutationOptions: MutationOptions<
    RemovefilesResponse,
    DefaultError,
    Options<RemovefilesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removefiles({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listallfilesQueryKey = (options: Options<ListallfilesData>) =>
  createQueryKey('listallfiles', options);

/**
 * List all files
 *
 * This API returns a list of files for the Release
 */
export const listallfilesOptions = (options: Options<ListallfilesData>) =>
  queryOptions<
    ListallfilesResponse,
    DefaultError,
    ListallfilesResponse,
    ReturnType<typeof listallfilesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallfiles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallfilesQueryKey(options),
  });

/**
 * Add files
 *
 * You can add files using this API to Release.
 */
export const addfilesMutation = (
  options?: Partial<Options<AddfilesData>>
): MutationOptions<AddfilesResponse, DefaultError, Options<AddfilesData>> => {
  const mutationOptions: MutationOptions<
    AddfilesResponse,
    DefaultError,
    Options<AddfilesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addfiles({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listAllSearchResultsQueryKey = (
  options: Options<ListAllSearchResultsData>
) => createQueryKey('listAllSearchResults', options);

/**
 * List All Search Results
 *
 * List All Search Results
 */
export const listAllSearchResultsOptions = (
  options: Options<ListAllSearchResultsData>
) =>
  queryOptions<
    ListAllSearchResultsResponse2,
    DefaultError,
    ListAllSearchResultsResponse2,
    ReturnType<typeof listAllSearchResultsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAllSearchResults({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAllSearchResultsQueryKey(options),
  });

export const listallSharesQueryKey = (options?: Options<ListallSharesData>) =>
  createQueryKey('listallShares', options);

/**
 * List all Shares
 *
 * This API will fetch all the shares by the user.
 *
 * If the calling user is the project admin, then the Response will have all shares for the  given projectId, else it will return the shares created by that user in project.
 *
 * If the projectId is not given, then the API Response will have shares across all the projects for the calling user.
 *
 * The default limit will be 25 elemenets, maximum of 1000 elements can be fetched on ranged Request
 */
export const listallSharesOptions = (options?: Options<ListallSharesData>) =>
  queryOptions<
    ListallSharesResponse,
    DefaultError,
    ListallSharesResponse,
    ReturnType<typeof listallSharesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallShares({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallSharesQueryKey(options),
  });

/**
 * Create a New Share
 *
 * You may create a new Share using this action.
 *
 * Depending on mode, for "PROJECT_USERS", valid values for "notify" object's "type" field are ['USER', 'GROUP'], and for other two modes, valid type is "EMAIL" (with "id" being the actual email address)
 *
 * For Objects array, in case of FILE object type, user can specify optional "useLatestVersion" boolean field. Defaults to "true".
 *
 * For "PROJECT_USERS" mode, "expiryDate", "permission", and "useLatestVersion" are defaulted and cannot be specified in the API.
 *
 * - expiryDate : never
 *
 * - permission : DOWNLOAD
 *
 * - useLatestVersion : TRUE
 */
export const createaNewShareMutation = (
  options?: Partial<Options<CreateaNewShareData>>
): MutationOptions<
  CreateaNewShareResponse,
  DefaultError,
  Options<CreateaNewShareData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNewShareResponse,
    DefaultError,
    Options<CreateaNewShareData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNewShare({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getShareDetailsWithAccessTokenUsingStokenQueryKey = (
  options: Options<GetShareDetailsWithAccessTokenUsingStokenData>
) => createQueryKey('getShareDetailsWithAccessTokenUsingStoken', options);

/**
 * Get Share Details along with public accesstoken.
 *
 * Get details of the particular share using share token along with accessToken to access the files shared in public mode
 */
export const getShareDetailsWithAccessTokenUsingStokenOptions = (
  options: Options<GetShareDetailsWithAccessTokenUsingStokenData>
) =>
  queryOptions<
    GetShareDetailsWithAccessTokenUsingStokenResponse,
    DefaultError,
    GetShareDetailsWithAccessTokenUsingStokenResponse,
    ReturnType<typeof getShareDetailsWithAccessTokenUsingStokenQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShareDetailsWithAccessTokenUsingStoken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getShareDetailsWithAccessTokenUsingStokenQueryKey(options),
  });

/**
 * Delete Share
 *
 * This API will allow you to revoke the share. Shared URLs will be invalidated.
 */
export const deleteShareMutation = (
  options?: Partial<Options<DeleteShareData>>
): MutationOptions<
  DeleteShareResponse,
  DefaultError,
  Options<DeleteShareData>
> => {
  const mutationOptions: MutationOptions<
    DeleteShareResponse,
    DefaultError,
    Options<DeleteShareData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteShare({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getShareDetailsQueryKey = (
  options: Options<GetShareDetailsData>
) => createQueryKey('getShareDetails', options);

/**
 * Get Share Details
 *
 * Get Share Details
 */
export const getShareDetailsOptions = (options: Options<GetShareDetailsData>) =>
  queryOptions<
    GetShareDetailsResponse,
    DefaultError,
    GetShareDetailsResponse,
    ReturnType<typeof getShareDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShareDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getShareDetailsQueryKey(options),
  });

/**
 * Edit Share
 *
 * This API allows you to update the properties of the Share.
 *
 * Depending on mode, for "PROJECT_USERS", valid values for "notify" object's "type" field are ['USER', 'GROUP'], and for other two modes, valid type is "EMAIL" (with "id" being the actual email address)
 *
 * For "PROJECT_USERS" mode, "expiryDate", "permission", and "useLatestVersion" are defaulted and cannot be specified in the API. The defaults are:
 *
 * - expiryDate : never
 * - permission : DOWNLOAD
 * - useLatestVersion : true
 */
export const editShareMutation = (
  options?: Partial<Options<EditShareData>>
): MutationOptions<EditShareResponse, DefaultError, Options<EditShareData>> => {
  const mutationOptions: MutationOptions<
    EditShareResponse,
    DefaultError,
    Options<EditShareData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await editShare({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listTagsinaprojectQueryKey = (
  options?: Options<ListTagsinaprojectData>
) => createQueryKey('listTagsinaproject', options);

/**
 * List Tags in a project
 *
 * API to list Tags under a project / mapped with an object
 */
export const listTagsinaprojectOptions = (
  options?: Options<ListTagsinaprojectData>
) =>
  queryOptions<
    ListTagsinaprojectResponse,
    DefaultError,
    ListTagsinaprojectResponse,
    ReturnType<typeof listTagsinaprojectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTagsinaproject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTagsinaprojectQueryKey(options),
  });

/**
 * Create Tag
 *
 * API to create a Tag under a project
 */
export const createTagMutation = (
  options?: Partial<Options<CreateTagData>>
): MutationOptions<CreateTagResponse, DefaultError, Options<CreateTagData>> => {
  const mutationOptions: MutationOptions<
    CreateTagResponse,
    DefaultError,
    Options<CreateTagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTag({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Tag
 *
 * API to delete a tag
 */
export const deleteTagMutation = (
  options?: Partial<Options<DeleteTagData>>
): MutationOptions<DeleteTagResponse, DefaultError, Options<DeleteTagData>> => {
  const mutationOptions: MutationOptions<
    DeleteTagResponse,
    DefaultError,
    Options<DeleteTagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTag({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTagDetailsQueryKey = (options: Options<GetTagDetailsData>) =>
  createQueryKey('getTagDetails', options);

/**
 * Get Tag Details
 *
 * API to fetch details of a tag
 */
export const getTagDetailsOptions = (options: Options<GetTagDetailsData>) =>
  queryOptions<
    GetTagDetailsResponse,
    DefaultError,
    GetTagDetailsResponse,
    ReturnType<typeof getTagDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTagDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTagDetailsQueryKey(options),
  });

/**
 * Edit Tag
 *
 * API to update the Tag properties
 */
export const editTagMutation = (
  options?: Partial<Options<EditTagData>>
): MutationOptions<EditTagResponse, DefaultError, Options<EditTagData>> => {
  const mutationOptions: MutationOptions<
    EditTagResponse,
    DefaultError,
    Options<EditTagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await editTag({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove objects from Tag
 *
 * API to remove objects from a tag
 * This API takes below request body <br/>
 * [<br/>
 * {<br/>
 * "id": "woC32em2Fb0",<br/>
 * "objectType": "FILE"<br/>
 * }<br/>
 * ]
 */
export const removeobjectsfromTagMutation = (
  options?: Partial<Options<RemoveobjectsfromTagData>>
): MutationOptions<
  RemoveobjectsfromTagResponse,
  DefaultError,
  Options<RemoveobjectsfromTagData>
> => {
  const mutationOptions: MutationOptions<
    RemoveobjectsfromTagResponse,
    DefaultError,
    Options<RemoveobjectsfromTagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeobjectsfromTag({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listobjectsinaTagQueryKey = (
  options: Options<ListobjectsinaTagData>
) => createQueryKey('listobjectsinaTag', options);

/**
 * List objects in a Tag
 *
 * API to list objects mapped to a tag
 */
export const listobjectsinaTagOptions = (
  options: Options<ListobjectsinaTagData>
) =>
  queryOptions<
    ListobjectsinaTagResponse,
    DefaultError,
    ListobjectsinaTagResponse,
    ReturnType<typeof listobjectsinaTagQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listobjectsinaTag({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listobjectsinaTagQueryKey(options),
  });

/**
 * Add objects to Tag
 *
 * API to map objects to a tag
 */
export const addobjectstoTagMutation = (
  options?: Partial<Options<AddobjectstoTagData>>
): MutationOptions<
  AddobjectstoTagResponse,
  DefaultError,
  Options<AddobjectstoTagData>
> => {
  const mutationOptions: MutationOptions<
    AddobjectstoTagResponse,
    DefaultError,
    Options<AddobjectstoTagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addobjectstoTag({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listallToDosQueryKey = (options: Options<ListallToDosData>) =>
  createQueryKey('listallToDos', options);

/**
 * List all ToDos
 *
 * This API returns the list of todos in a project based on either project Id or file
 * Id using which todos are created.
 */
export const listallToDosOptions = (options: Options<ListallToDosData>) =>
  queryOptions<
    ListallToDosResponse,
    DefaultError,
    ListallToDosResponse,
    ReturnType<typeof listallToDosQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallToDos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallToDosQueryKey(options),
  });

/**
 * Create a New ToDo
 *
 * You may create a new ToDo using this action.
 * + description (string) - The details of the ToDo
 * + projectId (string) - Project Identifier
 *
 * Optional parameters you can define on creation:
 * - type (follow  BCF 2.0 spec)
 * - title
 * - label
 * - dueDate
 * - percentComplete
 * - status
 * - priority
 * - assignees
 */
export const createaNewToDoMutation = (
  options?: Partial<Options<CreateaNewToDoData>>
): MutationOptions<
  CreateaNewToDoResponse,
  DefaultError,
  Options<CreateaNewToDoData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNewToDoResponse,
    DefaultError,
    Options<CreateaNewToDoData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNewToDo({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listallTodoTypesofaProjectQueryKey = (
  options: Options<ListallTodoTypesofaProjectData>
) => createQueryKey('listallTodoTypesofaProject', options);

/**
 * List all Todo Types of a Project
 *
 * List all Todo Types of a Project
 */
export const listallTodoTypesofaProjectOptions = (
  options: Options<ListallTodoTypesofaProjectData>
) =>
  queryOptions<
    ListallTodoTypesofaProjectResponse,
    DefaultError,
    ListallTodoTypesofaProjectResponse,
    ReturnType<typeof listallTodoTypesofaProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallTodoTypesofaProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallTodoTypesofaProjectQueryKey(options),
  });

/**
 * Delete a ToDo
 *
 * Delete a ToDo
 */
export const deleteToDoMutation = (
  options?: Partial<Options<DeleteToDoData>>
): MutationOptions<
  DeleteToDoResponse,
  DefaultError,
  Options<DeleteToDoData>
> => {
  const mutationOptions: MutationOptions<
    DeleteToDoResponse,
    DefaultError,
    Options<DeleteToDoData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteToDo({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getToDoDetailsQueryKey = (options: Options<GetToDoDetailsData>) =>
  createQueryKey('getToDoDetails', options);

/**
 * Get ToDo Details
 *
 * Get ToDo Details
 */
export const getToDoDetailsOptions = (options: Options<GetToDoDetailsData>) =>
  queryOptions<
    GetToDoDetailsResponse,
    DefaultError,
    GetToDoDetailsResponse,
    ReturnType<typeof getToDoDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getToDoDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getToDoDetailsQueryKey(options),
  });

/**
 * Update ToDo
 *
 * This API allows you to update the following properties of the ToDo:
 *
 * Note : Custom ToDo Label would not be updated from here.
 *
 * - type
 *
 * - title
 *
 * - label
 *
 * - description
 *
 * - dueDate
 *
 * - percentComplete
 *
 * - status
 *
 * - priority
 *
 * - assignees
 */
export const updateToDoMutation = (
  options?: Partial<Options<UpdateToDoData>>
): MutationOptions<
  UpdateToDoResponse,
  DefaultError,
  Options<UpdateToDoData>
> => {
  const mutationOptions: MutationOptions<
    UpdateToDoResponse,
    DefaultError,
    Options<UpdateToDoData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateToDo({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove attachments
 *
 * These sets of APIs allow you to remove attachments to a ToDo.
 */
export const removeattachmentsMutation = (
  options?: Partial<Options<RemoveattachmentsData>>
): MutationOptions<
  RemoveattachmentsResponse,
  DefaultError,
  Options<RemoveattachmentsData>
> => {
  const mutationOptions: MutationOptions<
    RemoveattachmentsResponse,
    DefaultError,
    Options<RemoveattachmentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeattachments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listallattachmentsQueryKey = (
  options: Options<ListallattachmentsData>
) => createQueryKey('listallattachments', options);

/**
 * List all attachments
 *
 * These sets of APIs allow you to list attachments to a ToDo.
 */
export const listallattachmentsOptions = (
  options: Options<ListallattachmentsData>
) =>
  queryOptions<
    ListallattachmentsResponse,
    DefaultError,
    ListallattachmentsResponse,
    ReturnType<typeof listallattachmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallattachments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallattachmentsQueryKey(options),
  });

/**
 * Add attachments
 *
 * These sets of APIs allow you to add attachments to a ToDo.
 */
export const addattachmentsMutation = (
  options?: Partial<Options<AddattachmentsData>>
): MutationOptions<
  AddattachmentsResponse,
  DefaultError,
  Options<AddattachmentsData>
> => {
  const mutationOptions: MutationOptions<
    AddattachmentsResponse,
    DefaultError,
    Options<AddattachmentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addattachments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listAllSupportedLanguagesQueryKey = (
  options?: Options<ListAllSupportedLanguagesData>
) => createQueryKey('listAllSupportedLanguages', options);

/**
 * List All Supported Languages
 *
 * Response is an array of all available Languages supported by Trimble Connect.
 */
export const listAllSupportedLanguagesOptions = (
  options?: Options<ListAllSupportedLanguagesData>
) =>
  queryOptions<
    ListAllSupportedLanguagesResponse,
    DefaultError,
    ListAllSupportedLanguagesResponse,
    ReturnType<typeof listAllSupportedLanguagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAllSupportedLanguages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAllSupportedLanguagesQueryKey(options),
  });

export const listUserLicensesQueryKey = (
  options?: Options<ListUserLicensesData>
) => createQueryKey('listUserLicenses', options);

/**
 * List User Licenses
 *
 * API to fetch licenses for a current user context
 *
 * An empty object for "license" property indicates that the user does not have any license mapped.
 */
export const listUserLicensesOptions = (
  options?: Options<ListUserLicensesData>
) =>
  queryOptions<
    ListUserLicensesResponse,
    DefaultError,
    ListUserLicensesResponse,
    ReturnType<typeof listUserLicensesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listUserLicenses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listUserLicensesQueryKey(options),
  });

export const listAllAvailableTimezonesQueryKey = (
  options?: Options<ListAllAvailableTimezonesData>
) => createQueryKey('listAllAvailableTimezones', options);

/**
 * List All Available Timezones
 *
 * Response is an array of all available Timezones supported by Trimble Connect.
 */
export const listAllAvailableTimezonesOptions = (
  options?: Options<ListAllAvailableTimezonesData>
) =>
  queryOptions<
    ListAllAvailableTimezonesResponse,
    DefaultError,
    ListAllAvailableTimezonesResponse,
    ReturnType<typeof listAllAvailableTimezonesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAllAvailableTimezones({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAllAvailableTimezonesQueryKey(options),
  });

export const getUserDetailsQueryKey = (options: Options<GetUserDetailsData>) =>
  createQueryKey('getUserDetails', options);

/**
 * Get User Details
 *
 * Get user details by Trimble Connect user identifier. Use `me` alias (`/users/me`) to get details about the user associated with the passed access token.
 */
export const getUserDetailsOptions = (options: Options<GetUserDetailsData>) =>
  queryOptions<
    GetUserDetailsResponse2,
    DefaultError,
    GetUserDetailsResponse2,
    ReturnType<typeof getUserDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserDetailsQueryKey(options),
  });

/**
 * Update User Details
 *
 * This API allows you to update the following properties of the User Details:
 *
 * - timeZone
 *
 * - language
 *
 * - phone
 *
 * - podLocation
 *
 * - viewerBackground
 *
 * Supported values for language : [`en-us`,`da-dk`,`de-de`,`es-es`,`fi-fi`,`fr-fr`,`it-it`,`ja-jp`,`ko-kr`,`nb-bo`,`nl-nl`,`pt-br`,`ru-ru`,`sv-se`,`zh-hans`,`zh-hant`]
 */
export const updateUserDetailsMutation = (
  options?: Partial<Options<UpdateUserDetailsData>>
): MutationOptions<
  UpdateUserDetailsResponse,
  DefaultError,
  Options<UpdateUserDetailsData>
> => {
  const mutationOptions: MutationOptions<
    UpdateUserDetailsResponse,
    DefaultError,
    Options<UpdateUserDetailsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateUserDetails({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listallViewGroupsQueryKey = (
  options: Options<ListallViewGroupsData>
) => createQueryKey('listallViewGroups', options);

/**
 * List all View Groups
 *
 * Get the list of all View Groups in a given project.
 */
export const listallViewGroupsOptions = (
  options: Options<ListallViewGroupsData>
) =>
  queryOptions<
    ListallViewGroupsResponse,
    DefaultError,
    ListallViewGroupsResponse,
    ReturnType<typeof listallViewGroupsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallViewGroups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallViewGroupsQueryKey(options),
  });

/**
 * Create a View Group
 *
 * Create a View Group
 */
export const createaViewGroupMutation = (
  options?: Partial<Options<CreateaViewGroupData>>
): MutationOptions<
  CreateaViewGroupResponse,
  DefaultError,
  Options<CreateaViewGroupData>
> => {
  const mutationOptions: MutationOptions<
    CreateaViewGroupResponse,
    DefaultError,
    Options<CreateaViewGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaViewGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a View Group
 *
 * You can use this API to delete a View Group.
 */
export const deleteViewGroupMutation = (
  options?: Partial<Options<DeleteViewGroupData>>
): MutationOptions<
  DeleteViewGroupResponse,
  DefaultError,
  Options<DeleteViewGroupData>
> => {
  const mutationOptions: MutationOptions<
    DeleteViewGroupResponse,
    DefaultError,
    Options<DeleteViewGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteViewGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getViewGroupDetailsQueryKey = (
  options: Options<GetViewGroupDetailsData>
) => createQueryKey('getViewGroupDetails', options);

/**
 * Get View Group Details
 *
 * Get the details of a View Group.
 */
export const getViewGroupDetailsOptions = (
  options: Options<GetViewGroupDetailsData>
) =>
  queryOptions<
    GetViewGroupDetailsResponse,
    DefaultError,
    GetViewGroupDetailsResponse,
    ReturnType<typeof getViewGroupDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getViewGroupDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getViewGroupDetailsQueryKey(options),
  });

/**
 * Update View Group Details
 *
 * Update the name and views in the View Group. The views list provided in the PATCH Request is applied.
 */
export const updateViewGroupDetailsMutation = (
  options?: Partial<Options<UpdateViewGroupDetailsData>>
): MutationOptions<
  UpdateViewGroupDetailsResponse,
  DefaultError,
  Options<UpdateViewGroupDetailsData>
> => {
  const mutationOptions: MutationOptions<
    UpdateViewGroupDetailsResponse,
    DefaultError,
    Options<UpdateViewGroupDetailsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateViewGroupDetails({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listallViewsinaprojectQueryKey = (
  options: Options<ListallViewsinaprojectData>
) => createQueryKey('listallViewsinaproject', options);

/**
 * List all Views in a project
 *
 * This API returns the list of views in a project based on either project Id or file Id using which views are created.
 */
export const listallViewsinaprojectOptions = (
  options: Options<ListallViewsinaprojectData>
) =>
  queryOptions<
    ListallViewsinaprojectResponse,
    DefaultError,
    ListallViewsinaprojectResponse,
    ReturnType<typeof listallViewsinaprojectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listallViewsinaproject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listallViewsinaprojectQueryKey(options),
  });

/**
 * Create View
 *
 * API to create a view. Note that imageData has been truncated in the example below.
 * View can be created on a project level or as view embedded to ToDo. For creating embedded view an todoId property must be given in the Request with valid existing ToDo identifier.
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const createViewMutation = (
  options?: Partial<Options<CreateViewData>>
): MutationOptions<
  CreateViewResponse,
  DefaultError,
  Options<CreateViewData>
> => {
  const mutationOptions: MutationOptions<
    CreateViewResponse,
    DefaultError,
    Options<CreateViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create View with image
 *
 * Create a view using form data. The form should have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 *
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const createViewWithThumbnailMutation = (
  options?: Partial<Options<CreateViewWithThumbnailData>>
): MutationOptions<
  CreateViewWithThumbnailResponse,
  DefaultError,
  Options<CreateViewWithThumbnailData>
> => {
  const mutationOptions: MutationOptions<
    CreateViewWithThumbnailResponse,
    DefaultError,
    Options<CreateViewWithThumbnailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createViewWithThumbnail({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update View with image
 *
 * Update a view using form data. The form can have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const updateViewWithThumbnailMutation = (
  options?: Partial<Options<UpdateViewWithThumbnailData>>
): MutationOptions<
  UpdateViewWithThumbnailResponse,
  DefaultError,
  Options<UpdateViewWithThumbnailData>
> => {
  const mutationOptions: MutationOptions<
    UpdateViewWithThumbnailResponse,
    DefaultError,
    Options<UpdateViewWithThumbnailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateViewWithThumbnail({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a View
 *
 * Delete a View
 */
export const deleteViewMutation = (
  options?: Partial<Options<DeleteViewData>>
): MutationOptions<
  DeleteViewResponse,
  DefaultError,
  Options<DeleteViewData>
> => {
  const mutationOptions: MutationOptions<
    DeleteViewResponse,
    DefaultError,
    Options<DeleteViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getViewDetailsQueryKey = (options: Options<GetViewDetailsData>) =>
  createQueryKey('getViewDetails', options);

/**
 * Get View Details
 *
 * Get View Details
 */
export const getViewDetailsOptions = (options: Options<GetViewDetailsData>) =>
  queryOptions<
    GetViewDetailsResponse,
    DefaultError,
    GetViewDetailsResponse,
    ReturnType<typeof getViewDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getViewDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getViewDetailsQueryKey(options),
  });

/**
 * Update a View
 *
 * Update a View
 */
export const updateViewMutation = (
  options?: Partial<Options<UpdateViewData>>
): MutationOptions<
  UpdateViewResponse,
  DefaultError,
  Options<UpdateViewData>
> => {
  const mutationOptions: MutationOptions<
    UpdateViewResponse,
    DefaultError,
    Options<UpdateViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCameraDetailsQueryKey = (
  options: Options<GetCameraDetailsData>
) => createQueryKey('getCameraDetails', options);

/**
 * Get Camera Details
 *
 * Get Camera Details
 */
export const getCameraDetailsOptions = (
  options: Options<GetCameraDetailsData>
) =>
  queryOptions<
    GetCameraDetailsResponse,
    DefaultError,
    GetCameraDetailsResponse,
    ReturnType<typeof getCameraDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCameraDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCameraDetailsQueryKey(options),
  });

/**
 * Update Camera
 *
 * Use this API to update a view's camera.  With the exception of the read-only fields: cameraId and viewId, all property could be updated.  For example, to update the up vector, just specify the necessary information the update:
 */
export const updateCameraMutation = (
  options?: Partial<Options<UpdateCameraData>>
): MutationOptions<
  UpdateCameraResponse,
  DefaultError,
  Options<UpdateCameraData>
> => {
  const mutationOptions: MutationOptions<
    UpdateCameraResponse,
    DefaultError,
    Options<UpdateCameraData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCamera({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getViewImageQueryKey = (options: Options<GetViewImageData>) =>
  createQueryKey('getViewImage', options);

/**
 * Get snapshot image for a View
 *
 * Returns the original size snapshot url as uploaded when view was created.
 */
export const getViewImageOptions = (options: Options<GetViewImageData>) =>
  queryOptions<
    GetViewImageResponse,
    DefaultError,
    GetViewImageResponse,
    ReturnType<typeof getViewImageQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getViewImage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getViewImageQueryKey(options),
  });

/**
 * Upload a Thumbnail Image for a View
 *
 * Upload a Thumbnail Image for a View
 */
export const uploadViewThumbnailImageMutation = (
  options?: Partial<Options<UploadViewThumbnailImageData>>
): MutationOptions<
  UploadViewThumbnailImageResponse2,
  DefaultError,
  Options<UploadViewThumbnailImageData>
> => {
  const mutationOptions: MutationOptions<
    UploadViewThumbnailImageResponse2,
    DefaultError,
    Options<UploadViewThumbnailImageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadViewThumbnailImage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listMarkupsQueryKey = (options: Options<ListMarkupsData>) =>
  createQueryKey('listMarkups', options);

/**
 * List Markups
 *
 * List Markups
 */
export const listMarkupsOptions = (options: Options<ListMarkupsData>) =>
  queryOptions<
    ListMarkupsResponse,
    DefaultError,
    ListMarkupsResponse,
    ReturnType<typeof listMarkupsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMarkups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMarkupsQueryKey(options),
  });

/**
 * Update a Markup
 *
 * Update a Markup
 */
export const updateMarkupMutation = (
  options?: Partial<Options<UpdateMarkupData>>
): MutationOptions<
  UpdateMarkupResponse,
  DefaultError,
  Options<UpdateMarkupData>
> => {
  const mutationOptions: MutationOptions<
    UpdateMarkupResponse,
    DefaultError,
    Options<UpdateMarkupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateMarkup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Markups
 *
 * API to create markups.
 */
export const createMarkupsMutation = (
  options?: Partial<Options<CreateMarkupsData>>
): MutationOptions<
  CreateMarkupsResponse,
  DefaultError,
  Options<CreateMarkupsData>
> => {
  const mutationOptions: MutationOptions<
    CreateMarkupsResponse,
    DefaultError,
    Options<CreateMarkupsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createMarkups({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a Markup
 *
 * Delete a Markup
 */
export const deleteMarkupMutation = (
  options?: Partial<Options<DeleteMarkupData>>
): MutationOptions<
  DeleteMarkupResponse,
  DefaultError,
  Options<DeleteMarkupData>
> => {
  const mutationOptions: MutationOptions<
    DeleteMarkupResponse,
    DefaultError,
    Options<DeleteMarkupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteMarkup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPresentationQueryKey = (
  options: Options<GetPresentationData>
) => createQueryKey('getPresentation', options);

/**
 * Get Presentation
 *
 * Get Presentation
 */
export const getPresentationOptions = (options: Options<GetPresentationData>) =>
  queryOptions<
    GetPresentationResponse,
    DefaultError,
    GetPresentationResponse,
    ReturnType<typeof getPresentationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPresentation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPresentationQueryKey(options),
  });

/**
 * Update a Presentation
 *
 * Update a Presentation
 */
export const updatePresentationMutation = (
  options?: Partial<Options<UpdatePresentationData>>
): MutationOptions<
  UpdatePresentationResponse,
  DefaultError,
  Options<UpdatePresentationData>
> => {
  const mutationOptions: MutationOptions<
    UpdatePresentationResponse,
    DefaultError,
    Options<UpdatePresentationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePresentation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Section Box
 *
 * Delete the view section box
 */
export const deleteSectionBoxMutation = (
  options?: Partial<Options<DeleteSectionBoxData>>
): MutationOptions<
  DeleteSectionBoxResponse,
  DefaultError,
  Options<DeleteSectionBoxData>
> => {
  const mutationOptions: MutationOptions<
    DeleteSectionBoxResponse,
    DefaultError,
    Options<DeleteSectionBoxData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteSectionBox({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSectionBoxQueryKey = (options: Options<GetSectionBoxData>) =>
  createQueryKey('getSectionBox', options);

/**
 * Get Section Box
 *
 * Use this API to get view section box.
 */
export const getSectionBoxOptions = (options: Options<GetSectionBoxData>) =>
  queryOptions<
    GetSectionBoxResponse,
    DefaultError,
    GetSectionBoxResponse,
    ReturnType<typeof getSectionBoxQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSectionBox({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSectionBoxQueryKey(options),
  });

/**
 * Create or Update Section Box
 *
 * Use this API to create or update a view's section box by supplying the full object in the Request body.
 */
export const updateSectionBoxMutation = (
  options?: Partial<Options<UpdateSectionBoxData>>
): MutationOptions<
  UpdateSectionBoxResponse,
  DefaultError,
  Options<UpdateSectionBoxData>
> => {
  const mutationOptions: MutationOptions<
    UpdateSectionBoxResponse,
    DefaultError,
    Options<UpdateSectionBoxData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateSectionBox({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listSectionPlanesQueryKey = (
  options: Options<ListSectionPlanesData>
) => createQueryKey('listSectionPlanes', options);

/**
 * List Section Planes
 *
 * Use this API to get a view section plane.
 */
export const listSectionPlanesOptions = (
  options: Options<ListSectionPlanesData>
) =>
  queryOptions<
    ListSectionPlanesResponse,
    DefaultError,
    ListSectionPlanesResponse,
    ReturnType<typeof listSectionPlanesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSectionPlanes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSectionPlanesQueryKey(options),
  });

/**
 * Update Section Plane
 *
 * Use this API to update a view section plane.
 */
export const updateSectionPlaneMutation = (
  options?: Partial<Options<UpdateSectionPlaneData>>
): MutationOptions<
  UpdateSectionPlaneResponse,
  DefaultError,
  Options<UpdateSectionPlaneData>
> => {
  const mutationOptions: MutationOptions<
    UpdateSectionPlaneResponse,
    DefaultError,
    Options<UpdateSectionPlaneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateSectionPlane({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Section Plane
 *
 * Use this API to add a view section plane. To add a view section plane, supply the full object in the Request body.
 */
export const createSectionPlaneMutation = (
  options?: Partial<Options<CreateSectionPlaneData>>
): MutationOptions<
  CreateSectionPlaneResponse,
  DefaultError,
  Options<CreateSectionPlaneData>
> => {
  const mutationOptions: MutationOptions<
    CreateSectionPlaneResponse,
    DefaultError,
    Options<CreateSectionPlaneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSectionPlane({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a Section Plane
 *
 * Delete a Section Plane
 */
export const deleteSectionPlaneMutation = (
  options?: Partial<Options<DeleteSectionPlaneData>>
): MutationOptions<
  DeleteSectionPlaneResponse,
  DefaultError,
  Options<DeleteSectionPlaneData>
> => {
  const mutationOptions: MutationOptions<
    DeleteSectionPlaneResponse,
    DefaultError,
    Options<DeleteSectionPlaneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteSectionPlane({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listall2dViewsQueryKey = (options?: Options<Listall2dViewsData>) =>
  createQueryKey('listall2dViews', options);

/**
 * List all 2D Views
 *
 * API to list 2D Views in a project based on either project Id or file Id using which views are created.
 */
export const listall2dViewsOptions = (options?: Options<Listall2dViewsData>) =>
  queryOptions<
    Listall2dViewsResponse,
    DefaultError,
    Listall2dViewsResponse,
    ReturnType<typeof listall2dViewsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listall2dViews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listall2dViewsQueryKey(options),
  });

/**
 * Create a New 2D View
 *
 * API to create a new 2D View. Thumbnail data can be attached as base64 encoded format in the Request.
 */
export const createaNew2dViewMutation = (
  options?: Partial<Options<CreateaNew2dViewData>>
): MutationOptions<
  CreateaNew2dViewResponse,
  DefaultError,
  Options<CreateaNew2dViewData>
> => {
  const mutationOptions: MutationOptions<
    CreateaNew2dViewResponse,
    DefaultError,
    Options<CreateaNew2dViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createaNew2dView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a new 2D View with image
 *
 * Create a 2dview using Multipart/form-data media type. The form should have two fields; one named views2d which is the stringified 2dview Json object, the other named imageData is the file to be used as thumbnail.
 */
export const createa2dViewMultipartMutation = (
  options?: Partial<Options<Createa2dViewMultipartData>>
): MutationOptions<
  Createa2dViewMultipartResponse,
  DefaultError,
  Options<Createa2dViewMultipartData>
> => {
  const mutationOptions: MutationOptions<
    Createa2dViewMultipartResponse,
    DefaultError,
    Options<Createa2dViewMultipartData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createa2dViewMultipart({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a 2D View with image
 *
 * Update a 2dview using Multipart/form-data media type. The form can have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 */
export const update2dViewMultipartMutation = (
  options?: Partial<Options<Update2dViewMultipartData>>
): MutationOptions<
  Update2dViewMultipartResponse,
  DefaultError,
  Options<Update2dViewMultipartData>
> => {
  const mutationOptions: MutationOptions<
    Update2dViewMultipartResponse,
    DefaultError,
    Options<Update2dViewMultipartData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update2dViewMultipart({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete 2D View
 *
 * API to delete 2D View by it's id.
 */
export const delete2dViewMutation = (
  options?: Partial<Options<Delete2dViewData>>
): MutationOptions<
  Delete2dViewResponse,
  DefaultError,
  Options<Delete2dViewData>
> => {
  const mutationOptions: MutationOptions<
    Delete2dViewResponse,
    DefaultError,
    Options<Delete2dViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete2dView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const get2dViewdetailsQueryKey = (
  options: Options<Get2dViewdetailsData>
) => createQueryKey('get2dViewdetails', options);

/**
 * Get 2D View details
 *
 * API to get details of a 2D View by it's Id.
 */
export const get2dViewdetailsOptions = (
  options: Options<Get2dViewdetailsData>
) =>
  queryOptions<
    Get2dViewdetailsResponse,
    DefaultError,
    Get2dViewdetailsResponse,
    ReturnType<typeof get2dViewdetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get2dViewdetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: get2dViewdetailsQueryKey(options),
  });

/**
 * Update 2D View
 *
 * API to update 2D View.
 */
export const update2dViewMutation = (
  options?: Partial<Options<Update2dViewData>>
): MutationOptions<
  Update2dViewResponse,
  DefaultError,
  Options<Update2dViewData>
> => {
  const mutationOptions: MutationOptions<
    Update2dViewResponse,
    DefaultError,
    Options<Update2dViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update2dView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete reserved data for a specific view and app
 */
export const deleteReservedViewDataMutation = (
  options?: Partial<Options<DeleteReservedViewDataData>>
): MutationOptions<
  DeleteReservedViewDataResponse,
  DefaultError,
  Options<DeleteReservedViewDataData>
> => {
  const mutationOptions: MutationOptions<
    DeleteReservedViewDataResponse,
    DefaultError,
    Options<DeleteReservedViewDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteReservedViewData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getReservedViewDataQueryKey = (
  options: Options<GetReservedViewDataData>
) => createQueryKey('getReservedViewData', options);

/**
 * Retrieve reserved data for a specific view and app
 */
export const getReservedViewDataOptions = (
  options: Options<GetReservedViewDataData>
) =>
  queryOptions<
    GetReservedViewDataResponse,
    DefaultError,
    GetReservedViewDataResponse,
    ReturnType<typeof getReservedViewDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReservedViewData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReservedViewDataQueryKey(options),
  });

/**
 * Create or update reserved data for a specific view
 */
export const putReservedViewDataMutation = (
  options?: Partial<Options<PutReservedViewDataData>>
): MutationOptions<
  PutReservedViewDataResponse,
  DefaultError,
  Options<PutReservedViewDataData>
> => {
  const mutationOptions: MutationOptions<
    PutReservedViewDataResponse,
    DefaultError,
    Options<PutReservedViewDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await putReservedViewData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
